import {segmentsData} from "../data/segments.js";
import {
    showPlaySegmentPageGraphic,
    showViewSpecialSegmentPageGraphic,
    turnMatchOrSegmentLoserGraphicOpaque
} from "./graphics.js";
import {
    applySentenceCase,
    getChampionshipDisplayName,
    getChampionshipPrestigeHtml,
    getFeudHypeIncreasedHtml,
    getFeudPotentialHtml,
    getFeudStartedHtml,
    getGimmickDebutHtml, getGimmickEffectivenessHtml,
    getGimmickEffectivenessLevelChangeHtml,
    getStarRatingHtml,
    makeGameRequest,
    replaceAll,
    showFactionReputationData
} from "./ui-helpers.js";
import {commaSeparate, getMonthsWord, toTitleCase, getRandomChoice, shuffle, captureError} from "../modules/helpers.js";
import {globals, globalUser} from "../modules/globals.js";
import {showSuperstarInformation, showTagteamInformation} from "./booking.js";
import {playSegment} from "../modules/segments.js";
import {getEventHypeHtml, showPlayMatchOrSegmentPage} from "./events.js"
import {checkTutorialStepAction} from "./tutorial.js";

function viewSpecialSegmentStart(segment) {
    let $matchInfo = $("#match-info");
    const $match = $("#match");
    $matchInfo.html('').removeClass('visibility-hidden').show();

    // Hide header
    $('.match-container-header-text').text('');

    // Show segment name
    $matchInfo.append(
        "<span class='font-bold display-block margin-bottom-2 faded-purple'>" + segment['name'] + "</span>"
    );

    // Add names and pronouns for formatting string
    let segmentTextObjects = segment['pronouns'].map(function (obj) {
        return Object.keys(obj).sort().map(function (key) {
            return obj[key];
        });
    }).flat();
    let segmentTexts = segmentsData[segment['name']];
    let segmentStartText = segmentTexts['start'];
    let segmentStartHtml =
        '<span class="font-bold display-block margin-bottom-15 medium-dark-grey segment-start-text">' +
        segmentStartText.formatUnicorn(segmentTextObjects) +
        '</span>';
    $(segmentStartHtml).hide().appendTo($matchInfo).fadeIn(700);

    $matchInfo.fadeIn('slow');

    // Check for 'Continue' button click for special segment
    $match.off('click', '#progress-segment-button');
    $match.on('click', '#progress-segment-button', function () {
        viewSpecialSegmentAction(segment);
    });

    $match.html('').show();
    $match.append('<div class="match-superstar-information information-box"></div>');
    const $matchSuperstarInformation = $('.match-superstar-information');
    $matchSuperstarInformation.hide();
    $('#continue-container').hide();

    // Add information box
    $(".match-container").fadeIn('slow');
    $('#superstar_info').html('');

    // Show 'continue' button
    $matchSuperstarInformation.before('' +
        '<div class="margin-sides-auto margin-top-15">' +
        '<button type="button" class="button retro-button" id="progress-segment-button">Continue</button>' +
        '<button type="button" class="button retro-button grey-button-background margin-left-8" ' +
            'id="back-to-special-segments-button">Back</button>' +
        '</div>');

    // Load graphics
    showViewSpecialSegmentPageGraphic(segment, false);
}

function viewSpecialSegmentAction(segment) {
    let $matchInfo = $("#match-info");

    // Add names and pronouns for formatting string
    let segmentTextObjects = segment['pronouns'].map(function (obj) {
        return Object.keys(obj).sort().map(function (key) {
            return obj[key];
        });
    }).flat();
    let segmentTexts = segmentsData[segment['name']];
    let segmentActionText = segmentTexts['action'];
    segmentActionText = segmentActionText.formatUnicorn(segmentTextObjects);
    segmentActionText = applySentenceCase(segmentActionText);

    let segmentActionHtml =
        '<span class="font-bold display-block margin-bottom-15 medium-dark-grey segment-action-text">' +
        segmentActionText +
        '</span>';
    $(segmentActionHtml).hide().appendTo($matchInfo).fadeIn(700);
    $('.segment-start-text').removeClass('medium-dark-grey').addClass('light-grey');

    // Load graphics
    showViewSpecialSegmentPageGraphic(segment, true);

    $('#progress-segment-button').remove();
}

function showViewSpecialSegmentsPageData(data) {
    const $specialSegmentsInventory = $("#special-segments-inventory");
    $specialSegmentsInventory.html('');
    $("#special-segments-selection").html('');

    if (data['error'] === 'wom') {
        notie.alert({type: 3, text: 'Special Segments are not available in Wrestling on Mars'});
        return false;
    }

    // Add special segments
    data.forEach(function (specialSegment) {
        let html = getViewSpecialSegmentItemHtml(specialSegment);
        $specialSegmentsInventory.append(html);
    });

    $("#special-segments-box").fadeIn('slow').removeClass('display-none');
    $specialSegmentsInventory.scrollTop(0);
}

function getViewSpecialSegmentItemHtml(specialSegment) {
    let iconName = (specialSegment['booked']) ? 'special_segments_icon_torn' : 'special_segments_icon';
    let iconText = (specialSegment['booked']) ? 'Used' : 'Not Used';

    // Show view button if special segment has been used
    let viewButton = '';
    let monthsToReuse = '';
    if (specialSegment['unlocked'] && specialSegment['booked']) {
        viewButton = '<button type="button" class="button retro-button condensed margin-top-15 blue-button-background ' +
            'view-special-segment" data-uid="' + specialSegment['uid'] + '">View</button>';

        let monthsWord = getMonthsWord(specialSegment['monthsToReuse']);
        monthsToReuse = '<div class="font-1p125em margin-bottom-7 medium-light-grey">{0} {1} to re-use</div>'.format(specialSegment['monthsToReuse'], monthsWord);
    }

    let lockedClass = '';
    if (!specialSegment['unlocked']) {
        lockedClass = ' locked'
    }

    let name = specialSegment['name'];

    return '<div class="special-segment-container' + lockedClass + '">' +
            '<div class="font-1p125em margin-bottom-12 font-bold">' +
                '<span>' + name + '</span>' +
                '<span class="float-right"><img alt="' + iconText + '" class="special-segment-container-icon" src="static/www/static/' + iconName + '.png"/></span>' +
            '</div>' +

            monthsToReuse +

            '<div class="font-1p125em margin-bottom-7 light-grey">' +
                getSpecialSegmentUnlockText(name) +
            '</div>' +

            '<div class="font-1p125em consequence-red">' +
                getSpecialSegmentConsequenceText(name) +
            '</div>' +

            '<span>' +
                viewButton +
            '</span>' +
        '</div>';
}

function getSpecialSegmentUnlockText(name) {
    let unlockText;
    switch (name) {
        case 'Car Explosion':
            unlockText = 'Run a blowoff on a custom feud with the word "Family" in it and get a 4.5' +
                '<i class="fa fa-star margin-left-3 margin-right-5"></i>rating or above. ' +
                'Click<i class="fa fa-refresh margin-left-5 margin-right-5"></i>when adding a feud to generate custom Feud names.';
            break;
        case 'Stunt Dive':
            unlockText = 'Discovered in the company library.';
            break;
        case 'Dummy Wrestling':
            unlockText = 'Train a superstar to 3<i class="fa fa-star margin-left-3 margin-right-5"></i>workrate using a trainer (not from a match).';
            break;
        case 'Timely Rescue':
            unlockText = 'Train a staff doctor to Level 3 or hire a Level 3 doctor.';
            break;
        case 'Helicopter Raid':
            unlockText = 'Complete the buyout of a competitor (Level 3 Talent Management Facility).';
            break;
        case 'Ring Invasion':
            unlockText = 'Get a hot superstar on a 10 match singles losing streak.';
            break;
        case 'Love Making':
            unlockText = 'Add a superstar gimmick with the "Degenerate" character and get it to 100% effectiveness.';
            break;
        case 'Celebrity Beatdown':
            unlockText = 'Run a custom production package (Level 3 Production Facility) with the word "Celebrity" in it.';
            break;
        case 'Hosedown':
            unlockText = 'Run a silly segment that gets hot.';
            break;
        case 'Anti-Company Rant':
            unlockText = 'Run a hot feud between a superstar and the company\'s owner.';
            break;
    }
    return unlockText;
}

function getSpecialSegmentConsequenceText(name) {
    let consequenceText;
    switch (name) {
        case 'Car Explosion':
            consequenceText = 'Superstar unavailable';
            break;
        case 'Stunt Dive':
            consequenceText = 'Superstar unavailable';
            break;
        case 'Dummy Wrestling':
            consequenceText = 'Unhappy superstars';
            break;
        case 'Timely Rescue':
            consequenceText = 'Staff Member unavailable';
            break;
        case 'Helicopter Raid':
            consequenceText = 'Superstar suspended';
            break;
        case 'Ring Invasion':
            consequenceText = 'Superstar suspended';
            break;
        case 'Love Making':
            consequenceText = '<img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small four-px margin-right-3"/> Penalty';
            break;
        case 'Celebrity Beatdown':
            consequenceText = '<img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small four-px margin-right-3"/> Penalty';
            break;
        case 'Hosedown':
            consequenceText = 'Unhappy superstars';
            break;
        case 'Anti-Company Rant':
            consequenceText = 'Superstar suspended';
            break;
    }
    return consequenceText;
}

function showGetAvailableSegmentItemsData({data, callbackFunction} = {}) {

    // Reset ui
    $('#segment-items-container').html('').show();
    $('.filter-segment-items-options').scrollTop(0);
    $('.filter-segment-items-option').removeClass('selected');
    $('.filter-segment-items-option:contains("All")').addClass('selected');

    // Add segment items
    data['availableSegmentItems'].forEach(function (item, itemIndex) {
        let segmentItemBookingHtml = getSegmentItemBookingHtml(item, itemIndex);
        $('#segment-items-container').append(segmentItemBookingHtml);
    });

    // Add 'Custom Package' segment item
    let customPackageSegmentItemHtml = getCustomPackageSegmentItemHtml(data);
    $('#segment-items-container').append(customPackageSegmentItemHtml);
    $('.custom-package-start-text').trigger('keyup');

    // Add unavailable segment items
    data['unavailableSegmentItems'].forEach(function (item, index) {
        let segmentItemBookingHtml = getLockedSegmentItemBookingHtml(item, index);
        $('#segment-items-container').append(segmentItemBookingHtml);
    });

    // Tutorial action check
    if (data['nextTutorialState']) {
        globals.game.tutorialState = data['nextTutorialState']
    }

    // Tutorial action check
    checkTutorialStepAction('click_book_segment_button');

    if (typeof callbackFunction === 'function') {
        callbackFunction()
    }
}

function getSegmentItemBookingHtml(segmentItem, index) {
    let tags = [];
    let isFactionSegment = segmentItem['factionSegment'];
    let levelHtml = getSegmentItemBookingLevelHtml(segmentItem);

    let consequenceHtml = '';
    if (segmentItem['consequence']) {
        let consequenceText = toTitleCase(segmentItem['consequence'].replace(/-/g, ' '));

        if ((consequenceText.search("Turn") >= 0 || consequenceText.search("Face") >= 0 ||
            consequenceText.search("Heel") >= 0) && consequenceText.search("Company") < 0 &&
            segmentItem['name'] !== 'New Alliance') {
            tags.push('alignment')
        }
        if (consequenceText.search("Champion") >= 0 || consequenceText.search("Title") >= 0) {
            tags.push('title')
        }
        if (consequenceText.search("Team") >= 0 || consequenceText.search("Tag") >= 0 || consequenceText.search("Trio") >= 0) {
            tags.push('team')
        }
        if (consequenceText.search("Faction") >= 0) {
            tags.push('faction');
        }
        if (consequenceText.search("Brand") >= 0) {
            tags.push('brand');
        }

        consequenceHtml =
            '<div class="line-height-1p4 faded-red-light padding-top-3 segment-item-consequence">' +
            consequenceText +
            '</div>'
    }

    let requirementHtml = '';
    if (segmentItem['requirement']) {
        if (segmentItem['productionSegment']) {
            tags.push('production')
        }

        let requirementText = toTitleCase(segmentItem['requirement'].replace(/-/g, ' '));
        if (requirementText.search("Champion") >= 0 || requirementText.search("Title") >= 0) {
            tags.push('title')
        }
        if ((requirementText.search("Turn") >= 0 || requirementText.search("Face") >= 0 ||
            requirementText.search("Heel") >= 0 || requirementText.search("Neutral") >= 0) &&
            requirementText.search("Company") < 0 && segmentItem['name'] !== 'New Alliance') {
            tags.push('alignment')
        }
        if (requirementText.search("Team") >= 0 || requirementText.search("Tag") >= 0) {
            tags.push('team')
        }
        if (requirementText.search("Retirement") >= 0 || requirementText.search("Legend") >= 0) {
            tags.push('retired')
        }
        if (requirementText.search("Manager") >= 0 || requirementText.search("Managed") >= 0) {
            tags.push('manager')
        }
        if (requirementText.search("Brand") >= 0) {
            tags.push('brand')
        }
        requirementHtml =
            '<div class="line-height-1p4 padding-top-1 sky-blue">' +
            requirementText +
            '</div>'
    }

    let helpClass = '';
    let titleHtml = '';
    if (segmentItem['description']) {
        helpClass = ' help-text';
        titleHtml = ' title="' + segmentItem['description'] + '"';
    }

    let name = '<span class="segment-item-name">' + segmentItem['name'] + '</span>';

    let silly = '';
    if (segmentItem['silly']) {
        silly = '<div class="puke-green-dark segment-item-silly">Silly</div>';
        tags.push('silly');
    }

    let oneAtATime = '';
    if (!segmentItem['oneAtATime']) {
        oneAtATime =
            '<div class="light-grey help-text" title="A Repeatable Segment can be used multiple times at an Event or in a Feud without a penalty">' +
            'Repeatable' +
            '</div>';
        tags.push('repeatable');
    }

    let feudOnly = '';
    if (segmentItem['feudOnly']) {
        feudOnly =
            '<div class="light-grey segment-item-feud-only">' +
            'Feuds Only' +
            '</div>';
    }

    let maxParticipants = '';
    if (isFactionSegment && segmentItem['maxParticipants'] > 0) {
        maxParticipants = '<div class="light-grey">Select a Faction</div>';
    } else {
        if (segmentItem['maxParticipants'] !== undefined) {
            let participantsText = 'Participant';
            if (segmentItem['maxParticipants'] !== 1) {
                participantsText = 'Participants'
            }

            let numberOfParticipants = segmentItem['maxParticipants'];
            if (segmentItem['minParticipants'] !== segmentItem['maxParticipants']) {
                numberOfParticipants = '{0}-{1}'.format(segmentItem['minParticipants'], numberOfParticipants)
            }
            if (numberOfParticipants === 0) {
                numberOfParticipants = 'No'
            }

            maxParticipants = '<div class="light-grey">' + numberOfParticipants +
                ' ' + participantsText + '</div>';
        }
    }
    let noParticipants = '';
    if (segmentItem['maxParticipants'] === 0) {
        noParticipants = ' data-no-participants="true"'
    }

    if (segmentItem['chooseWinner']) {
        tags.push('choose-winner')
    }

    if (segmentItem['custom']) {
        tags.push('custom')
    }

    if (segmentItem['special']) {
        tags.push('special');
    }

    if ((segmentItem['consequence'] && segmentItem['consequence'].search("blowoff") >= 0) || (segmentItem['hypeBoost'] && segmentItem['minParticipants'] > 1) ||
        (['Solo Feud Promo', 'Client Betrayal'].indexOf(segmentItem['name']) >= 0)) {
        tags.push('feud');
    }

    let boosts =
        '<span class="faded-red help-text" ' +
        'title="Hype Boost for the involved Feuds">' +
        '<i class="fa fa-bolt margin-right-5"></i>' + segmentItem['hypeBoost'] +
        '</span>' +
        '<span class="charisma-purple margin-left-10 help-text" ' +
        'title="Popularity Boost for the involved Participant(s)">' +
        '<i class="fa fa-angle-double-up margin-right-5"></i>' + segmentItem['popularityBoost'] +
        '</span>';

    if (segmentItem['special']) {
        if (segmentItem['used']) {
            boosts = '<img alt="Used Special Segment" src="static/www/static/special_segments_icon_torn.png" class="special-segments-icon"/>'
        } else {
            boosts = '<img alt="Special Segment" src="static/www/static/special_segments_icon.png" class="special-segments-icon"/>'
        }
    }

    let itemUsed = '';
    if (segmentItem['used']) {
        itemUsed = '<div class="dark-red">Used</div>';
    }

    let progressHtml = getSegmentItemBookingProgressHtml(segmentItem);
    let sortAttributesHtml = getSegmentItemBookingSortAttributesHtml(segmentItem, index);

    let stats =
        '<div><span class="segment-item-label margin-right-5 medium-grey help-text" ' +
        'title="Entertainment: Affects a Segment\'s maximum Rating and XP gain">Ent.</span>' +
        '<i class="fa fa-star dark-grey"></i>'.repeat(segmentItem['entertainment']) +
        '<i class="fa fa-star light-grey"></i>'.repeat(3 - segmentItem['entertainment']) +
        '</div>' +
        '<div><span class="segment-item-label margin-right-5 medium-grey help-text" ' +
        'title="Action: Affects a Segment\'s maximum Rating and XP gain">Act.</span>' +
        '<i class="fa fa-star dark-grey"></i>'.repeat(segmentItem['action']) +
        '<i class="fa fa-star light-grey"></i>'.repeat(3 - segmentItem['action']) +
        '</div>' +
        '<div><span class="segment-item-label margin-right-5 medium-grey help-text" ' +
        'title="Difficulty: Used alongside the Charisma of the Participants to get the Segment\'s ' +
        'Effectiveness and Rating">Diff.</span>' +
        '<i class="fa fa-star dark-grey"></i>'.repeat(segmentItem['difficulty']) +
        '<i class="fa fa-star light-grey"></i>'.repeat(3 - segmentItem['difficulty']) +
        '</div>';

    let info =
        '<div>' +
        maxParticipants + oneAtATime + feudOnly + silly + requirementHtml + consequenceHtml + itemUsed +
        '</div>';

    // Check for faction input
    let factionInputAttr = '';
    if (['remove-faction-members', 'add-faction-members', 'leave-faction-and-join-other-faction',
        'merge-factions', 'split-faction', 'add-faction-leader', 'kick-out-faction-leader-and-change-leader',
        'change-faction-leader', 'create-faction'].indexOf(segmentItem['consequence']) >= 0) {
        factionInputAttr = ' data-faction-input="true"';
    }

    // Check for manager input
    let managerInputAttr = '';
    if (['boost-managed-talent', 'add-manager', 'remove-manager', 'remove-managed-talent'].indexOf(segmentItem['consequence']) >= 0) {
        managerInputAttr = ' data-manager-input="true"';
    }

    // Check for brand input
    let brandInputAttr = '';
    if (['draft-talent-to-brand'].indexOf(segmentItem['consequence']) >= 0) {
        brandInputAttr = ' data-brand-input="true"';
    }

    // Check for other input
    let otherInputAttr = '';
    if (['loser-unavailable', 'make-unavailable', 'create-team', 'create-trio-of-heels',
            'remove-tag-team-and-create-tag-team', 'create-tag-team-and-blowoff', 'unify-titles',
            'split-title', 'vacate-title', 'award-title', 'boost-popularity'].indexOf(segmentItem['consequence']) >= 0 ||
        segmentItem['requirement'] === 'feud-present' || segmentItem['name'] === 'Slander Competitor') {
        otherInputAttr = ' data-other-input="true"';
    }

    return '<div class="segment-item-container wide item-container font-bold' +
        helpClass + '" data-uid="' + segmentItem['uid'] +
        '"' + noParticipants + titleHtml + ' data-name="' + segmentItem['name'].replace(/"/g, "&quot;") +
        '" data-requirement="' + segmentItem['requirement'] + '" data-consequence="' +
        segmentItem['consequence'] + '"' + factionInputAttr + managerInputAttr + brandInputAttr + otherInputAttr +
        sortAttributesHtml +
        ' data-tags=\'' + JSON.stringify(tags) + '\' data-is-faction-segment="' + isFactionSegment + '" ' +
        'tabindex="0">' +

        '<div class="margin-bottom-5">' +
        '<div class="column-left">' +
        name +
        '</div>' +
        '<div class="column-right segment-right-header-container">' +
        '<div class="column-left">' +
        progressHtml + levelHtml +
        '</div>' +
        '<div class="column-right text-right ">' +
        boosts +
        '</div>' +
        '<div class="clear"></div>' +
        '</div>' +
        '<div class="clear"></div>' +
        '</div>' +

        '<div class="column-left">' +
        stats +
        '</div>' +
        '<div class="column-right margin-top-1 segment-item-information">' +
        info +
        '</div>' +
        '<div class="clear"></div>' +
        '</div>';
}

function getLockedSegmentItemBookingHtml(segmentItem, index) {

    let levelHtml = getSegmentItemBookingLevelHtml(segmentItem);

    // Locked text
    let lockedText;
    if (segmentItem['productionSegment'] || segmentItem['special']) {
        lockedText = ''
    } else if (segmentItem['factionSegment']) {
        lockedText = ''
    } else if (['Option C', 'New Title Reveal', 'Championship Split'].indexOf(segmentItem['name']) >= 0) {
        lockedText = ''
    } else if (['boost-managed-talent', 'add-manager', 'remove-manager', 'remove-managed-talent',
        'draft-talent-to-brand'].indexOf(segmentItem['consequence']) >= 0) {
        lockedText = ''
    } else if (['other-brand-talent'].indexOf(segmentItem['requirement']) >= 0) {
        lockedText = ''
    } else {
        lockedText = 'Locked: Unlocked with Segment Item Prestige';
        if (!globalUser.paid) {
            lockedText += ' (JoW Paid)'
        }
    }

    // Tags
    let tags = [];
    tags.push('locked');

    // Silly
    let silly = '';
    if (segmentItem['silly']) {
        silly = '<div class="puke-green-dark segment-item-silly">Silly</div>';
        tags.push('silly');
    }

    // Consequence
    let consequenceHtml = '';
    if (segmentItem['consequence']) {
        let consequenceText = toTitleCase(segmentItem['consequence'].replace(/-/g, ' '));

        if ((consequenceText.search("Turn") >= 0 || consequenceText.search("Face") >= 0 ||
            consequenceText.search("Heel") >= 0) && consequenceText.search("Company") < 0 &&
            segmentItem['name'] !== 'New Alliance') {
            tags.push('alignment')
        }
        if (consequenceText.search("Champion") >= 0 || consequenceText.search("Title") >= 0) {
            tags.push('title')
        }
        if (consequenceText.search("Team") >= 0 || consequenceText.search("Tag") >= 0 || consequenceText.search("Trio") >= 0) {
            tags.push('team')
        }
        if (consequenceText.search("Faction") >= 0) {
            tags.push('faction');
        }
        if (consequenceText.search("Brand") >= 0) {
            tags.push('brand');
        }

        consequenceHtml =
            '<div class="line-height-1p4 faded-red-light padding-top-3 segment-item-consequence">' +
            consequenceText +
            '</div>'
    }

    // Requirement
    let requirement = '';
    if (segmentItem['requirement']) {
        if (segmentItem['productionSegment']) {
            tags.push('production')
        }

        let requirementText = toTitleCase(segmentItem['requirement'].replace(/-/g, ' '));
        if (requirementText.search("Champion") >= 0 || requirementText.search("Title") >= 0) {
            tags.push('title')
        }
        if (requirementText.search("Turn") >= 0 || requirementText.search("Face") >= 0 ||
            requirementText.search("Heel") >= 0) {
            tags.push('alignment')
        }
        if (requirementText.search("Team") >= 0 || requirementText.search("Tag") >= 0) {
            tags.push('team')
        }
        if (requirementText.search("Retirement") >= 0 || requirementText.search("Legend") >= 0) {
            tags.push('retired')
        }
        requirement =
            '<div class="line-height-1p4 padding-top-1 sky-blue">' +
            requirementText +
            '</div>'
    }

    // One at a time
    let oneAtATime = '';
    if (!segmentItem['oneAtATime']) {
        oneAtATime =
            '<div class="light-grey help-text" title="A Repeatable Segment can be used multiple times at an Event or in a Feud without a penalty">' +
            'Repeatable' +
            '</div>';
        tags.push('repeatable');
    }

    // Feud only
    let feudOnly = '';
    if (segmentItem['feudOnly']) {
        feudOnly =
            '<div class="light-grey segment-item-feud-only">' +
            'Feuds Only' +
            '</div>';
    }

    // Max participants
    let maxParticipants = '';
    if (segmentItem['maxParticipants'] !== undefined) {
        let participantsText = 'Participant';
        if (segmentItem['maxParticipants'] !== 1) {
            participantsText = 'Participants'
        }

        let numberOfParticipants = segmentItem['maxParticipants'];
        if (segmentItem['minParticipants'] !== segmentItem['maxParticipants']) {
            numberOfParticipants = '{0}-{1}'.format(segmentItem['minParticipants'], numberOfParticipants)
        }
        if (numberOfParticipants === 0) {
            numberOfParticipants = 'No'
        }

        maxParticipants = '<div class="light-grey">' + numberOfParticipants + ' ' + participantsText + '</div>';
    }

    // Custom
    if (segmentItem['custom']) {
        tags.push('custom')
    }

    // Special
    if (segmentItem['special']) {
        tags.push('special')
    }

    // Feud tag
    if ((segmentItem['consequence'] && segmentItem['consequence'].search("blowoff") >= 0) ||
        (segmentItem['hypeBoost'] && segmentItem['minParticipants'] > 1)) {
        tags.push('feud');
    }

    // Hidden stats
    let stats =
        '<div><span class="segment-item-label margin-right-5 medium-grey">Ent.</span>' +
        '???' +
        '</div>' +
        '<div><span class="segment-item-label margin-right-5 medium-grey">Act.</span>' +
        '???' +
        '</div>' +
        '<div><span class="segment-item-label margin-right-5 medium-grey">Diff.</span>' +
        '???' +
        '</div>';

    // Boosts
    let boosts = '<span>' +
        '<i class="fa fa-bolt margin-right-5"></i>' + '??' +
        '</span>' +
        '<span class="margin-left-8">' +
        '<i class="fa fa-angle-double-up margin-right-5"></i>' + '??' +
        '</span>';
    if (segmentItem['special']) {
        boosts = '<img alt="Special Segment" src="static/www/static/special_segments_icon.png" class="special-segments-icon"/>'
    }

    // Info
    let info =
        '<div>' +
        maxParticipants + oneAtATime + feudOnly + silly + requirement + consequenceHtml +
        '</div>';

    // Unlock text
    let unlockText = '';
    let unlockedBy = getSegmentItemUnlockedBy(segmentItem['name']);
    if (segmentItem['productionSegment']) {
        unlockText = ' Locked: Unlocked by ' + unlockedBy;
        if (!globalUser.paid) {
            unlockText += ' (JoW Paid)'
        }
    } else if (segmentItem['factionSegment']) {
        unlockText = 'Available in JoW Paid';
    } else if (['Option C', 'New Title Reveal', 'Championship Split'].indexOf(segmentItem['name']) >= 0) {
        unlockText = ' Locked: Unlocked by getting a ' + unlockedBy;
        if (!globalUser.paid) {
            unlockText += ' (JoW Paid)'
        }
    } else if (['boost-managed-talent', 'add-manager', 'remove-manager', 'remove-managed-talent',
        'draft-talent-to-brand'].indexOf(segmentItem['consequence']) >= 0) {
        unlockText = 'Available in JoW Paid';
    } else if (['other-brand-talent'].indexOf(segmentItem['requirement']) >= 0) {
        unlockText = 'Available in JoW Paid';
    } else if (segmentItem['special']) {
        unlockText = ' Locked: Unlocked by completing a specific action (\'Manage\' > \'Other\' > \'Special\')';
    } else {
        unlockText = ' by getting Gold Prestige on ' + unlockedBy;
    }

    let progressHtml = getSegmentItemBookingProgressHtml(segmentItem);
    let sortAttributesHtml = getSegmentItemBookingSortAttributesHtml(segmentItem, index);

    return '<div class="wide item-container font-bold disabled locked help-text" ' +
        'title="' + lockedText + unlockText + '" ' +
        ' data-name="' + segmentItem['name'].replace(/"/g, "&quot;") +
        '" data-requirement="' + segmentItem['requirement'] + '" data-consequence="' +
        segmentItem['consequence'] + '"' + sortAttributesHtml +
        ' data-tags=\'' + JSON.stringify(tags) + '\'>' +

        '<div class="margin-bottom-5">' +
        '<div class="column-left">' +
        segmentItem['name'] +
        '</div>' +
        '<div class="column-right segment-right-header-container">' +
        '<div class="column-left">' +
        progressHtml + levelHtml +
        '</div>' +
        '<div class="column-right text-right ">' +
        boosts +
        '</div>' +
        '<div class="clear"></div>' +
        '</div>' +
        '<div class="clear"></div>' +
        '</div>' +

        '<div class="column-left">' +
        stats +
        '</div>' +
        '<div class="column-right margin-top-1">' +
        info +
        '</div>' +
        '<div class="clear"></div>' +
        '</div>';
}

function getSegmentItemBookingLevelHtml(item) {
    let levelHtml = '';
    if (!item['special']) {
        switch (item['level']) {
            case 1:
                levelHtml = '<i class="fa fa-star-o margin-left-6 font-bold font-16px top-4px bronze"></i>';
                break;
            case 2:
                levelHtml = '<i class="fa fa-star-o margin-left-6 font-bold font-16px top-4px silver"></i>';
                break;
            case 3:
                levelHtml = '<i class="fa fa-star-o margin-left-6 font-bold font-16px top-4px gold-light"></i>';
                break;
        }
    }
    return levelHtml;
}

function getSegmentItemBookingProgressHtml(item) {
    // Get progress to next level
    let progress;
    let levelXp;
    if (item['level'] < 3) {
        levelXp = Math.pow(item['level'], 2) * 75;
        progress = (item['xp'] / levelXp) * 100;
    } else {
        levelXp = Math.pow(2, 2) * 75;
        progress = 100;
    }
    // Hide progress for special segment items
    let progressClass = (item['special']) ? ' visibility-hidden' : '';
    return '<div class="segment-item-progress-container display-inline-block' + progressClass + '">' +
        '<div class="progress-under help-text" title="' + item['xp'] + ' / ' + levelXp + ' XP">' +
        '<div class="progress faded-purple-background" style="width:' + progress + '%">' + '</div>' +
        '</div>' +
        '</div>';
}

function getSegmentItemBookingSortAttributesHtml(item, index) {
    return ' data-default-order="' + index +
        '" data-participants="' + item['maxParticipants'] +
        '" data-hype-boost="' + item['hypeBoost'] +
        '" data-popularity-boost="' + item['popularityBoost'] +
        '" data-entertainment="' + item['entertainment'] +
        '" data-action="' + item['action'] +
        '" data-difficulty="' + item['difficulty'] + '"';
}

function getCustomPackageSegmentItemHtml(data) {
    let tags = ['production'];
    let name = '<span class="segment-item-name">Custom Package</span>';
    let itemRequirement = 'Level 1 Producer';

    let packageName =
        '<input type="text" placeholder="Name" ' +
        'class="styled-input custom-package-name" ' +
        'value="Feature Package">';

    let startText =
        '<input type="text" placeholder="Start Text" ' +
        'class="styled-input custom-package-start-text" ' +
        'value="A video package airs about {name} ..." maxlength="200">';

    let actionText =
        '<input type="text" placeholder="Action Text" ' +
        'class="styled-input custom-package-action-text" value="It praises {objective} and ' +
        'showcases {possessive} accomplishments." maxlength="250">';

    let inputsDiv =
        '<div class="font-0p85em">' +
        '<div class="margin-bottom-10">' +
        '<div>Name</div>' + packageName +
        '</div>' +
        '<div class="margin-bottom-10">' +
        '<div>Start Text</div>' + startText +
        '</div>' +
        '<div class="margin-bottom-10">' +
        '<div>Action Text</div>' + actionText +
        '<div class="add-custom-package-action-text-container cursor-pointer light-grey">' +
        '<i class="fa fa-minus-circle remove-custom-package-action-text-button display-none margin-right-3"></i>' +
        '<i class="fa fa-plus-circle add-custom-package-action-text-button"></i>' +
        '</div>' +
        '</div>' +
        '</div>';

    let helpDiv =
        '<div class="custom-package-help-container display-none margin-top-10 medium-dark-grey">' +
        '<div class="margin-bottom-5">The following keywords, when entered into the Start and Action Texts, ' +
        'will be replaced by a talent\'s details:</div>' +
        '<div class="margin-bottom-5">{name}</div>' +
        '<div class="margin-bottom-5">{pronoun} <span class="light-grey margin-left-2">he/she/they</span></div>' +
        '<div class="margin-bottom-5">{possessive} <span class="light-grey margin-left-2">his/her/their</span></div>' +
        '<div class="margin-bottom-10">{objective} <span class="light-grey margin-left-2">him/her/them</span></div>' +
        '<div>You can also add multiple Action Texts by clicking on the \'+\' icon. One of them will be chosen ' +
        'when the segment runs.</div>' +
        '</div>';

    let buttons =
        '<div class="light-grey float-right custom-package-help-button">help</div>' +
        '<button type="button" class="button retro-button blue-button-background margin-top-5 ' +
        'condensed" id="create-custom-package-button">Create</button>';

    let outputDivs =
        '<div class="margin-top-20 custom-package-preview-container">' +
        '<div class="margin-bottom-5 faded-purple custom-package-name-preview"></div>' +
        '<div class="margin-bottom-10 medium-dark-grey custom-package-start-text-preview"></div>' +
        '<div class="margin-bottom-10 medium-dark-grey custom-package-action-text-preview"></div>' +
        '</div>';

    let customPackageClass = '';
    let customPackageTitle = '';
    if (!data['customPackage']) {
        customPackageClass = ' locked help-text';
        customPackageTitle = ' title="You need to have an Advanced (Level 3) Production Facility and a ' +
            'Level 3 Producer to create a custom package."'
    }
    return '<div class="item-container wide input font-bold' + customPackageClass + '" ' + customPackageTitle +
        ' data-name="Custom Package" data-requirement="' + itemRequirement + '" ' +
        'data-tags=\'' + JSON.stringify(tags) + '\'>' +
        '<div class="margin-bottom-8">' +
        name +
        '<span class="float-right blue">' +
        ' <img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small margin-left-5 margin-right-5"/>30</span>' +
        '</div>' +
        '<div class="column-left">' +
        inputsDiv +
        buttons +
        helpDiv +
        '</div>' +
        '<div class="column-right text-right">' +
        outputDivs +
        '</div>' +
        '<div class="clear"></div>' +
        '</div>';
}

function getSegmentItemUnlockedBy(feudItemName) {
    let unlockedByName;
    switch (feudItemName) {
        case 'Legend\'s Praise':
            unlockedByName = 'Debut';
            break;
        case 'Title Destruction':
            unlockedByName = 'Title Disrespect';
            break;
        case 'Exposing the Past':
            unlockedByName = 'Anger Management';
            break;
        case 'Lost My Smile':
            unlockedByName = 'Demand Title Shot';
            break;
        case 'You\'re Fired':
            unlockedByName = 'Talk Show';
            break;
        case 'Defying a Villain':
            unlockedByName = 'Spirited Promo';
            break;
        case 'Backstab':
            unlockedByName = 'Heat Promo';
            break;
        case 'Delayed Vengeance':
            unlockedByName = 'Fight';
            break;
        case 'Option C':
            unlockedByName = 'Bronze Prestige Championship to Silver Prestige';
            break;
        case 'New Title Reveal':
            unlockedByName = 'Silver Prestige Championship to Gold Prestige';
            break;
        case 'Championship Split':
            unlockedByName = 'Gold Prestige Championship to Obsidian Prestige';
            break;
        case 'Debut Package':
            unlockedByName = 'getting your Producer to Level 2';
            break;
        case 'Return Package':
            unlockedByName = 'getting your Producer to Level 2';
            break;
        case 'Champion Package':
            unlockedByName = 'getting your Producer to Level 2';
            break;
        case 'Career Package':
            unlockedByName = 'getting your Producer to Level 3';
            break;
        case 'Day in the Life':
            unlockedByName = 'getting your Producer to Level 3';
            break;
        case 'Entrance Parody':
            unlockedByName = 'Siblings Parody';
            break;
        case 'Police Arrest':
            unlockedByName = 'Backstage Attack';
            break;
        case 'One Last Run':
            unlockedByName = 'Legendary Beatdown';
            break;
        case 'This Is My Life':
            unlockedByName = 'Backstage Interview';
            break;
        case 'Spouse Attack':
            unlockedByName = 'Home Invasion';
            break;
        case 'Face Reveal':
            unlockedByName = 'Masked Attacker';
            break;
        case 'Catchphrase Showdown':
            unlockedByName = 'Promo Battle';
            break;
    }
    return unlockedByName;
}

async function showPlaySegmentPage({matchesAndSegmentsData, index = 0, tournamentDisplay, cashinData} = {}) {
    const $match = $("#match");
    const matchInfoSelector = $("#match-info");
    let stageLayers;

    // Get segment
    let segment = matchesAndSegmentsData[index];

    // Show header
    $('.match-container-header-text').text('Next Segment');

    // Run annual tournament segment, display only
    if (segment['annualTournament']) {
        return viewAnnualTournamentSegmentStart(segment, matchesAndSegmentsData, index, tournamentDisplay);
    }

    // Reset ui
    matchInfoSelector.html('').removeClass('visibility-hidden').show();
    $match.data('played', false);

    // Show segment name
    matchInfoSelector.append(
        "<span class='font-bold display-block margin-bottom-3 faded-purple'>" + segment['name'] + "</span>"
    );

    // Show feud names
    let feudsHtmlArray = [];
    segment['feuds'].forEach(function (feud) {
        feudsHtmlArray.push("<span class='help-text' title='" + feud['participants'].join(' vs ').replace(/'/g, "&#39;") + "'>" +
            feud['name'] +
            "</span>");
    });
    if (feudsHtmlArray.length > 0) {
        matchInfoSelector.append(
            "<span class='font-bold display-block margin-bottom-3 faded-red-light'>" + commaSeparate(feudsHtmlArray, '&') + "</span>"
        );
    }

    // Show hype
    let segmentHype = segment['hype'];
    if (segmentHype < 0) {
        segmentHype = '- ' + (segmentHype * -1)
    }
    else {
        segmentHype = '+ ' + segmentHype
    }
    matchInfoSelector.append(
        "<span class='font-bold display-block medium-dark-grey margin-bottom-3'>" + segmentHype + " HYPE</span>"
    );

    // Show segment start text
    showSegmentStartText(segment);
    matchInfoSelector.fadeIn('slow');

    // Get data type
    let dataType = '';
    if (segment['participantsType'] === 'tag') {
        dataType = 'tagTeam'
    }

    // Check for 'Continue' button click for special segment
    let participantsDisplay = '';
    if (segment['special']) {
        $match.off('click', '#progress-segment-button');
        $match.on('click', '#progress-segment-button', async function () {
            await makeGameRequest(playSegment, {winnerName: null, uid: segment['uid'], graphics: segment['graphics']},
                showPlaySegmentData, {segment, winnerName: null, cashinData, tournamentDisplay, matchesAndSegmentsData,
                    index, stageLayers}, false);
        });
    }
    // Run segment result if no winner to be chosen
    else if (!segment['chooseWinner']) {
        $('#booking-talent-info').addClass('match').hide();
        setTimeout(async function () {
            await makeGameRequest(playSegment, {winnerName: null, uid: segment['uid'], graphics: segment['graphics']},
                showPlaySegmentData, {segment, winnerName: null, cashinData, tournamentDisplay, matchesAndSegmentsData,
                    index, stageLayers}, false);
        }, 2800);
    }
    // Choose winner
    else {
        // Create x vs x vs x ...
        let participantsHtml = [];
        if (segment['participants'].length > 10) {
            $match.css('text-align', 'left');
            segment['participants'].forEach(function (participant) {
                participantsHtml.push(
                    '<div class="match-wrestler-container-battle-royal">' +
                    '<button class="match-wrestler match-span-small" data-type="' + dataType +
                    '" data-name="' + participant['name'].replace(/"/g, "&quot;") + '">' +
                    getMatchOrSegmentParticipantName(participant) + '</button></div>');
            });
        }
        else {
            $match.css('text-align', 'center');
            segment['participants'].forEach(function (participant) {
                participantsHtml.push('<div class="match-wrestler-container">' +
                    '<button class="match-wrestler match-span" data-type="' + dataType +
                    '" data-name="' + participant['name'].replace(/"/g, "&quot;") + '">' +
                    getMatchOrSegmentParticipantName(participant) + '</button></div>');
            });
        }
        if (segment['participants'].length > 4) {
            participantsDisplay = participantsHtml.join('');
        }
        else {
            participantsDisplay = participantsHtml.join('<span class="match-span dark-grey"></span>');
        }

        $('#booking-talent-info').addClass('match').hide();

        // Show information handler
        let timer;
        $match.off('mouseenter', '.match-wrestler');
        $match.on({
            mouseenter: function () {
                let $this = $(this);
                timer = setTimeout(function () {
                    let selectedName = $this.text();
                    if ($this.attr('data-name')) {
                        selectedName = $this.attr('data-name')
                    }
                    let member = segment['participants'].filter(function (obj) {
                        return obj.name === selectedName;
                    })[0];
                    if (member) {
                        if ($this.attr('data-type') === 'tagTeam') {
                            showTagteamInformation(member, true);
                        }
                        else {
                            showSuperstarInformation(member, true);
                        }
                    }
                }, 70);
            },
            mouseleave: function () {
                clearTimeout(timer);
            }
        }, ".match-wrestler");

        // Ask to choose winner
        notie.alert({type: 4, text: 'Select who performs the Segment', stay: true});
    }

    // Show participants
    $match.html(participantsDisplay);

    // Remove simulate button
    $('#simulate-match').remove();

    // Show match elements
    if (segment['chooseWinner']) {
        $match.append('<button type="button" ' +
            'class="button retro-button margin-top-15 margin-sides-auto display-block" id="simulate-match" ' +
            'data-segment-uid="' + segment['uid'] + '">Simulate</button>');
        // Add information box
        $match.append('<div class="match-superstar-information information-box">' +
            '<div class="superstar-info-match-container">' +
            'Participant Details' +
            '<div class="empty-superstar-info light-grey">' +
            '<div class="vertical-center">Hover over a Participant to display their details here</div>' +
            '</div>' +
            '</div>' +
            '</div>');
    }
    else {
        $match.append('<div class="match-superstar-information information-box"></div>');
        $('.match-superstar-information').hide();
    }
    $match.show();
    $('#booking-talent-info').html('');
    $('.match-container').fadeIn('fast');

    // Show 'continue' button if special segment
    if (segment['special']) {
        $('.match-superstar-information').before('<button type="button" class="button retro-button margin-top-15 ' +
                'margin-sides-auto display-block grey-button-background" ' +
                'id="progress-segment-button">Continue</button>');
    }

    // Show graphics
    if (segment['graphics'].length > 0) {
        stageLayers = showPlaySegmentPageGraphic(segment);
    }

    // Simulate handler
    $match.off('click', '#simulate-match');
    $match.on('click', '#simulate-match', function () {
        if ($match.data('played')) {
            return;
        }
        let winnerDiv = $(getRandomChoice($('#match .match-wrestler')));
        winnerDiv.trigger('click');
    });

    // Winner click handler
    $(document).off('click', '#match .match-wrestler');
    $(document).on({
        click: async function (event) {
            if ($(this).hasClass('match-wrestler')) {
                $(this).unbind(event);

                let winnerName = $(this).text();
                if ($(this).attr('data-name')) {
                    winnerName = $(this).attr('data-name')
                }

                // Put winner first in pronouns
                segment['pronouns'].sort(function (x, y) {
                    return x['name'] === winnerName ? -1 : y['name'] === winnerName ? 1 : 0;
                });

                await makeGameRequest(playSegment, {winnerName, uid: segment['uid'], graphics: segment['graphics']},
                    showPlaySegmentData, {segment, winnerName, cashinData, tournamentDisplay, matchesAndSegmentsData,
                        index, stageLayers}, false);
            }
        }
    }, "#match .match-wrestler");
}

function showSegmentStartText(segment) {
    let segmentStartText = getSegmentStartText(segment);
    $(segmentStartText).hide().appendTo($("#match-info")).fadeIn(700);
}

function getSegmentStartText(segment) {
    let segmentStartText;
    if (segment['startTexts'] && segment['startTexts'].length) {
        // Custom text
        segmentStartText = formatSegmentText(getRandomChoice(segment['startTexts']))
    }
    else if (segment['text']) {
        // Custom segment text
        let segmentText = segment['text'];

        // Get singles or tag text
        if (segmentText['startTag'] && segment['participantsType'] === 'tag') {
            segmentStartText = formatSegmentText(getRandomChoice(segmentText['startTag']));
        }
        else {
            segmentStartText = formatSegmentText(getRandomChoice(segmentText['start']));
        }
    }
    else {
        let segmentTexts = segmentsData[segment['name']];

        // Get texts based on number of participants if text has this data
        if (segmentTexts['participants']) {
            segmentTexts = segmentTexts['participants'][segment['participantsNumber']]
        }

        // Get faction texts
        if (segment['factionSegment']) {
            if (segment['factionSuperstarsMultiple']) {
                segmentStartText = segmentTexts['startTag']
            }
            else {
                segmentStartText = segmentTexts['start']
            }
        }
        // Get singles or tag text
        else {
            if (segmentTexts['startTag'] && segment['participantsType'] === 'tag') {
                segmentStartText = segmentTexts['startTag'];
            }
            else {
                segmentStartText = segmentTexts['start']
            }
        }
    }

    // Add names and pronouns for formatting string
    let segmentTextObjects = segment['pronouns'].map(function (obj) {
        return Object.keys(obj).sort().map(function (key) {
            return obj[key];
        });
    }).flat();

    return '<span class="font-bold display-block margin-bottom-10 margin-top-10 medium-dark-grey segment-start-text">' +
        segmentStartText.formatUnicorn(segmentTextObjects) +
        '</span>';
}

function showPlaySegmentData({data, segment, winnerName, cashinData, tournamentDisplay, matchesAndSegmentsData, index,
                                 stageLayers} = {}) {
    if (!data['error']) {
        try {
            // Mark segment as played
            $('#match').data('played', true);

            // Update graphics if special segment or updated in data
            if (segment['special']) {
                stageLayers = showPlaySegmentPageGraphic(segment, true);
            }
            if (data['graphics']) {
                segment['graphics'] = data['graphics'];
                stageLayers = showPlaySegmentPageGraphic(segment);
            }

            // Add losing layer, pop changes
            turnMatchOrSegmentLoserGraphicOpaque(segment, winnerName, stageLayers);
            showSegmentPopularityChanges(data, segment, winnerName);

            // Show segment action text, result
            showSegmentActionText(segment);
            showSegmentResult(data, segment, winnerName);

            // Show updates
            showSegmentUpdates(data, segment);
            showUpdatesContainers();
            animateGimmickEffectiveness();

            // Update segments if returned
            if (data['mainEventHype']) {
                matchesAndSegmentsData[matchesAndSegmentsData.length - 1]['hype'] = data['mainEventHype'];
                // Update event hype
                $('.event-hype-text').html(getEventHypeHtml(data['eventHype'])).hide().fadeIn('fast');
            }

            // Show 'continue' button, hide simulate button
            $('#progress-segment-button').remove();
            $('.match-superstar-information').before('<button type="button" class="button retro-button margin-top-15 ' +
                'margin-sides-auto display-block grey-button-background" ' +
                'id="progress-segment-button">Continue</button>');
            $('#simulate-match').hide();

            // Increase index
            index++;

            // Progress segment handler
            $("#match").off('click', '#progress-segment-button');
            $("#match").on('click', '#progress-segment-button', async function () {
                await showPlayMatchOrSegmentPage({data: {'matchesAndSegmentsData': matchesAndSegmentsData,
                    'cashinData': cashinData, 'tournamentDisplay': tournamentDisplay}, index});
                // Tutorial action check
                checkTutorialStepAction('click_segment_continue');
            });

            // Tutorial action check
            if (data['nextTutorialState']) {
                globals.game.tutorialState = data['nextTutorialState']
            }

            // Tutorial action check
            checkTutorialStepAction('select_segment_winner');
            checkTutorialStepAction('play_segment');
        }
        catch (error) {
            captureError(error)
        }
    }
    else {
        let text;
        if (data['error'] === 'team-members-not-found') {
            text = 'Team members could not be found for {0}. Try removing this Segment.'.format(data['teamName']);
        }
        else if (data['error'] === 'championship-not-selected') {
            text = 'Please rebook this segment and select a championship to award.';
        } else {
            text = 'There was an error playing this Segment';
        }
        notie.alert({type: 3, text: text});
    }
}

function showSegmentPopularityChanges(data, segment, winnerName) {
    $(".match-wrestler").each(function (i) {
        let wrestlerDiv = $(this);
        let wrestlerName = wrestlerDiv.text();
        if (wrestlerDiv.attr('data-name')) {
            wrestlerName = wrestlerDiv.attr('data-name')
        }
        let singles = (segment['participants'].length === 2);

        // Losers
        if (!(wrestlerName === winnerName)) {
            $(this).addClass('opaque');  // Darken losers' names
        }
        // Winner
        else {
            // Show winner' changes if participants are 10 or less
            if (segment['participants'].length <= 10) {
                if (data['popularityChange'] !== null) {
                    let increase = data['popularityChange'];

                    let color = 'green';
                    if (increase < 0) {
                        color = 'dark-red';
                        increase = '- ' + (increase * -1)
                    } else {
                        increase = '+ ' + increase
                    }

                    if (singles) {
                        if (i === 1) {
                            $(this).parent().prepend('<div class="match-stat ' + color + '">'
                                + increase + '</div>');
                        } else {
                            $(this).parent().prepend('<div class="match-stat ' + color + '">' +
                                increase + '</div>');
                        }
                    } else {
                        $(this).parent().prepend('<div class="match-stat ' + color + '">' +
                            increase + '</div>');
                    }
                }
            }
        }
    });

    // Show popularity change
    $("#match").find('.match-stat, .match-stat-large-tag').each(function () {
        $(this).hide().slideDown('slow');
    });
}

function showSegmentActionText(segment) {
    let segmentActionText = getSegmentActionText(segment);
    $(segmentActionText).hide().appendTo($("#match-info")).fadeIn(700);
    $('.segment-start-text').removeClass('medium-dark-grey').addClass('light-grey');
}

function getSegmentActionText(segment) {
    let segmentActionText;
    if (segment['actionTexts'] && segment['actionTexts'].length) {
        // Custom text
        segmentActionText = formatSegmentText(getRandomChoice(segment['actionTexts']))
    }
    else if (segment['text']) {
        // Get singles or tag custom text
        let segmentText = segment['text'];
        if (segmentText['actionTag'] && segment['participantsType'] === 'tag') {
            segmentActionText = formatSegmentText(getRandomChoice(segmentText['actionTag']));
        }
        else {
            segmentActionText = formatSegmentText(getRandomChoice(segmentText['action']));
        }
    }
    else {
        let segmentTexts = segmentsData[segment['name']];

        // Get texts based on number of participants if text has this data
        if (segmentTexts['participants']) {
            segmentTexts = segmentTexts['participants'][segment['participantsNumber']]
        }

        // Get faction texts
        if (segment['factionSegment']) {
            if (segment['factionSuperstarsMultiple']) {
                segmentActionText = segmentTexts['actionTag']
            }
            else {
                segmentActionText = segmentTexts['action']
            }
        }
        // Get singles or tag text
        else {
            if (segmentTexts['actionTag'] && segment['participantsType'] === 'tag') {
                segmentActionText = segmentTexts['actionTag'];
            }
            else {
                segmentActionText = segmentTexts['action']
            }
        }

        if (segmentTexts['choices']) {
            let choice;
            if (segment['participantsType'] === 'tag' && segmentTexts['choicesTag']) {
                choice = getRandomChoice(segmentTexts['choicesTag'])
            }
            else {
                choice = getRandomChoice(segmentTexts['choices']);
            }

            segmentActionText = segmentActionText.format(choice);
            // Shuffle participants for generated text
            segment['participants'] = shuffle(segment['participants']);
        }
    }

    // Format segment text objects
    let segmentTextObjects = getSegmentTextObjects(segment);
    segmentActionText = segmentActionText.formatUnicorn(segmentTextObjects);

    // Apply sentence case for special segments
    if (segment['special']) {
        segmentActionText = applySentenceCase(segmentActionText)
    }

    return '<span class="font-bold display-block medium-dark-grey segment-action-text">' +
         segmentActionText +
        '</span>';
}

function getSegmentTextObjects(segment) {
    // Get names and pronouns
    let segmentTextObjects = segment['pronouns'].map(function (obj) {
        return Object.keys(obj).sort().map(function (key) {
            return obj[key];
        });
    }).flat();

    // Highlight patreon superstar for Local Squash segment
    if (segment['name'] === 'Local Squash' && segment['usePatreonSuperstar']) {
        segmentTextObjects[segmentTextObjects.length - 1] = '<span class="faded-blue help-text" title="A Face of the Company Patreon who somehow ended up backstage">' +
            segmentTextObjects[segmentTextObjects.length - 1] + '</span>'
    }

    return segmentTextObjects;
}

function showSegmentResult(data, segment, winnerName) {
    // Show result
    let eventResultsSelector = $("#event-match-results");
    let segmentResultHtml = getSegmentResultHtml(data, segment, winnerName);
    eventResultsSelector.find('.empty-event-match-results-text').remove();
    eventResultsSelector.fadeIn('slow');
    eventResultsSelector.find('.event-results-header').after(
        '<div class="margin-bottom-8 match-result" tabindex="0">' +
        segmentResultHtml +
        '</div>'
    );

    // Show segment text in results
    let segmentText = $('.segment-start-text').text() + ' ' + $('.segment-action-text').text();
    eventResultsSelector.find('.match-result').first().after(
        '<span class="display-block margin-bottom-20 dark-grey segment-result-text">' + segmentText +
        '</span>'
    );
}

function getSegmentResultHtml(data, segment, winnerName) {
    // Load match result settings
    let matchResultSetting = globalUser.settings['matchResult'];
    let XPClass = 'match-result-xp';
    let overnessClass = 'match-result-overness';
    let popularityClass = 'match-result-popularity';
    let feudsClass = 'match-result-feuds';
    let gimmickEffectivenessClass = 'match-result-gimmick-effectiveness';
    let moraleClass = 'match-result-morale';
    let eventUpdatesFeudsSelector = $(".event-updates-feuds .updates-container");
    if (matchResultSetting) {
        if (!matchResultSetting.xp) {
            XPClass += ' display-none'
        }
        if (!matchResultSetting.overness) {
            overnessClass += ' display-none'
        }
        if (!matchResultSetting.popularity) {
            popularityClass += ' display-none'
        }
        if (!matchResultSetting.gimmickEffectiveness) {
            gimmickEffectivenessClass += ' display-none'
        }
        if (!matchResultSetting.feuds) {
            feudsClass += ' display-none'
        }
        if (matchResultSetting.morale === false) {
            moraleClass += ' display-none'
        }
    }
    else {
        XPClass += ' display-none';
        gimmickEffectivenessClass += ' display-none'
    }

    // For segments without choosing a winner
    if (!winnerName) {
        winnerName = data['winnerName']
    }

    // Add participant names, xp and pop change
    let icon = 'fa-angle-double-up';
    let popClass = 'green';
    if (data['popularityChange'] < 0) {
        data['popularityChange'] *= -1;
        icon = 'fa-angle-double-down';
        popClass = 'dark-red';
    }
    if (data['hotSegment']) {
        popClass = 'hot-color'
    }

    let participantsData = [];
    data['participantsData'].forEach(function (participant) {
        let html = '';
        let gimmickEffectivenessChange = '';
        if (participant['gimmickEffectivenessChange']) {
            // Show effectiveness change
            let prefix = '+ ';
            if (participant['gimmickEffectivenessChange'] < 0) {
                prefix = '- ';
                participant['gimmickEffectivenessChange'] *= -1;
            }
            gimmickEffectivenessChange = '<span class="character-label margin-left-8 ' + gimmickEffectivenessClass + ' help-text" title="Gimmick Effectiveness Change">' +
                prefix + participant['gimmickEffectivenessChange'] + '<span class="margin-left-2">%</span></span>'
        }

        let overnessChange = '';
        let participantOvernessChange = participant['overnessChange'];
        if (participantOvernessChange) {
            let prefix = '+ ';
            if (participantOvernessChange < 0) {
                prefix = '- ';
                participantOvernessChange *= -1;
                overnessChange = '<span class="stale-color ' + overnessClass + ' margin-left-8 help-text" title="Overness Change">' + prefix +
                    participantOvernessChange + '<span class="margin-left-2">%</span></span>'
            }
            else {
                overnessChange = '<span class="hot-color ' + overnessClass + ' margin-left-8 help-text" title="Overness Change">' + prefix +
                    participantOvernessChange + '<span class="margin-left-2">%</span></span>'
            }
        }

        let hotOrStaleIcon = '';
        if (participant['hot']) {
            hotOrStaleIcon = '<img alt="Hot" src="static/www/static/hot_icon.png" class="fire-image margin-left-5 help-text ' + overnessClass +
                '" title="Being Over boosts ' +
                ' a Superstar\'s Charisma, Popularity changes and Gimmick Effectiveness changes in Segments.">'
        }
        else if (participant['stale']) {
            hotOrStaleIcon = '<img alt="Stale" src="static/www/static/stale_icon.png" class="fire-image margin-left-5 help-text ' + overnessClass +
                '" title="Being Stale' +
                ' lowers the ratings of a Superstar\'s Segments and their Popularity gains.">'
        }

        // Morale change
        let moraleChange = '';
        let participantMoraleChange = participant['moraleChange'];
        if (participantMoraleChange) {
            let prefix = '+ ';
            if (participantMoraleChange < 0) {
                prefix = '- ';
                participantMoraleChange *= -1;
                moraleChange = '<span class="margin-left-8 morale-dissatisfied-color ' + moraleClass + ' help-text" title="Morale Change">' + prefix +
                    participantMoraleChange + '<span class="margin-left-2">%</span></span>'
            }
            else {
                moraleChange = '<span class="margin-left-8 light-green ' + moraleClass + ' help-text" title="Morale Change">' + prefix +
                    participantMoraleChange + '<span class="margin-left-2">%</span></span>'
            }
        }

        html += participant['name'] + hotOrStaleIcon;
        if (!segment['productionSegment'] && participant['xpGained'] !== undefined) {
            html += '<span class="faded-purple margin-left-8 + ' + XPClass + ' help-text" title="XP Change">+ ' + participant['xpGained'] + ' XP</span>'
        }
        html += gimmickEffectivenessChange + overnessChange + moraleChange;
        if (data['popularityChange'] !== null) {
            // Show popularity change
            let winnerCheck = participant['name'] === winnerName;
            if (data['hotSegment'] || winnerCheck) {
                html += '<span class="' + popClass + ' ' + popularityClass + ' help-text" title="Popularity Change">' +
                    '<i class="fa ' + icon + ' margin-left-8 margin-right-5"></i>' +
                    data['popularityChange'] + '</span>'
            }
        }

        // Get managers
        let managersHtml = getEventResultParticipantManagersHtml(participant['managersData'], 'segment');
        html += managersHtml;

        participantsData.push(html);
    });

    // Join participants
    let participantsHtml;
    if (participantsData.length > 1) {
        participantsHtml = participantsData.slice(0, -1).join(', ') + ' <span class="grey">and</span> ' +
            participantsData.slice(-1);
    }
    else {
        if (participantsData.length > 0) {
            participantsHtml = participantsData[0]
        }
        else {
            if (data['consequenceRunOn']) {
                // Add consequence run on (production segments)
                participantsHtml = data['consequenceRunOn'];
                // Show hype boost
                if (data['hypeBoostAdded']) {
                    participantsHtml += '<span class="faded-red">' +
                        '<i class="fa fa-angle-double-up margin-left-8 margin-right-8"></i>' +
                        '<i class="fa fa-bolt margin-right-5"></i>' + data['hypeBoostAdded'] +
                        '</span>';
                }
                // Show popularity boost
                if (data['popularityBoostAdded']) {
                    participantsHtml += '<span class="medium-grey">' +
                        '<i class="fa fa-angle-double-up margin-left-8 margin-right-8"></i>' +
                        data['popularityBoostAdded'] +
                        '</span>';
                }
            }
            else {
                if (segment['pronouns'].length > 0) {
                    participantsHtml = segment['pronouns'][0]['name'];
                }
            }
        }
    }

    // Add feuds and hype change
    let feudsHtml = '';
    data['feuds'].forEach(function (feud) {
        // Hype change
        let hypeChange;
        if (feud['hypeChange'] < 0) {
            feud['hypeChange'] *= -1;
            hypeChange = '<i class="fa fa-angle-double-down margin-left-8 margin-right-8"></i>' +
                '<i class="fa fa-bolt margin-right-5"></i>' +
                feud['hypeChange'];
        }
        else {
            hypeChange = '<i class="fa fa-angle-double-up margin-left-8 margin-right-8"></i>' +
                '<i class="fa fa-bolt margin-right-5"></i>' +
                feud['hypeChange'];
        }

        let feudName = feud['name'];
        if (feud['ended']) {
            feudName += ' <span class="bright-red">Blowoff</span>';
        }
        else if (feud['stale']) {
            let participantNames = feud['participants'].join(' and ');
            let feudName = feud['name'];
            let overnessChange = '<span class="stale-color">' + feud['overnessDecrease'] +
                                    '<span class="margin-left-2">%</span></span>';
            let text =
                '<span class="faded-red-light">' + feudName + '</span>' +
                ' Feud between ' + participantNames + ' became <span class="stale-color">Stale</span>' +
                ' with the Fans, lowering the Overness of its Participants by ' + overnessChange + ' each and decreasing its Hype.';
            eventUpdatesFeudsSelector.prepend('<span class="display-block event-match-effect margin-bottom-12">' +
                text +
                '</span>');
        }
        else if (feud['staleWarning']) {
            let participantNames = feud['participants'].join(' and ');
            let feudName = feud['name'];
            let text =
                '<span class="faded-red-light">' + feudName + ' Feud</span>' +
                ' between ' + participantNames +
                ' is starting to become <span class="stale-color">Stale</span> with the Fans.';
            eventUpdatesFeudsSelector.prepend('<span class="display-block event-match-effect margin-bottom-12">' +
                text +
                '</span>');
        }
        let feudClass = 'faded-red-light';
        if (data['hotSegment'] || feud['hot']) {
            feudClass = 'hot-color'
        }
        feudsHtml +=
            '<span class="margin-left-8 ' + feudsClass + '">' +
                '<span class="faded-red-light">' + feudName + '</span>' +
                    '<span class="' + feudClass + '">' +
                    '<i class="fa fa-bolt margin-right-5 margin-left-8"></i>' +
                    feud['hype'] +
                    '<span class="faded-red">' + hypeChange + '</span>' +
                '</span>' +
            '</span>';

    });

    // Set rating
    let rating;
    let ratingText;
    let ratingValue = data['rating'];
    let ratingFloor = Math.floor(ratingValue);
    if (ratingFloor === 0) {
        ratingText = '<i class="fa fa-star star-under"></i>'.repeat(5);
    }
    else {
        let decimalRating = ratingValue - ratingFloor;
        ratingText = '<i class="fa fa-star"></i>'.repeat(ratingFloor);
        if (decimalRating) {
            if (decimalRating === 0.75) {
                decimalRating = 0.70;
            }
            else if (decimalRating === 0.25) {
                decimalRating = 0.35;
            }
            ratingText += '<i class="star star-under fa fa-star">' +
                '<i class="star star-over fa fa-star" style="width: ' + decimalRating * 100 + '%"></i>' +
                '</i>';
            if (ratingFloor < 5) {
                ratingText += '<i class="fa fa-star star-under"></i>'.repeat(5 - ratingFloor - 1);
            }
        }
        else {
            if (ratingFloor < 5) {
                ratingText += '<i class="fa fa-star star-under"></i>'.repeat(5 - ratingFloor);
            }
        }
    }
    rating = '<span class="display-block match-star-rating help-text" title="Rating: Determined by a Segment\'s ' +
        'Effectiveness and its Entertainment and Action points">' +
        '<span class="dark-grey" role="text" aria-label="' + data['rating'] + ' stars' + '">' +
        ratingText +
        '</span></span>';

    // Show effectiveness
    let effectiveness = '<span class="display-block margin-top-10 help-text" title="Effectiveness: Determined by a Segment\'s ' +
        'Difficulty and the Charisma of the Participants.">' +
        '<span class="grey">' +
        (Math.round((parseFloat(data['effectiveness']) * 100) * 100) / 100) + '% Eff.' +
        '</span></span>';

    // Show negative multiplier
    let alreadyHeld = '';
    if (data['segmentAlreadyHeld']) {
        alreadyHeld =
            '<span class="display-block margin-top-2 help-text" ' +
            'title="Using a Segment already held at the Event or in the Feud reduces its Rating">' +
            '<span class="grey">Already held</span></span>'
    }

    // Show pure multipliers
    let pureBoost = '';
    if (data['pureNegativeBoost']) {
        pureBoost =
            '<span class="display-block margin-top-2 help-text" ' +
            'title="Silly Segments have a chance to decrease Segment ratings in a Pure Company">' +
            '<span class="grey">Silly Decrease</span></span>'
    }
    else if (data['purePositiveBoost']) {
        pureBoost =
            '<span class="display-block margin-top-2 help-text" ' +
            'title="Action focused Segments have a chance to increase Segment ratings in a Pure Company">' +
            '<span class="grey">Action Boost</span></span>'
    }

    // Show silly result
    let sillyResult = '';
    if (data['sillySuccess']) {
        sillyResult =
            '<span class="display-block margin-top-2 help-text" ' +
            'title="Silly Segments with a high Rating can be comedy gold, further boosting the Segment\'s Rating">' +
            '<span class="gold">Comedy Gold</span></span>'
    }
    else if (data['sillyFailure']) {
        sillyResult =
            '<span class="display-block margin-top-2 help-text" ' +
            'title="Silly Segments with a low Rating can be a flop, further lowering the Segment\'s Rating">' +
            '<span class="puke-green">Flop</span></span>'
    }

    // Producer focus effect
    let producerFocusEffectHtml = '';
    if (data['ratingData'] && data['ratingData']['producerFocusEffect']) {
        let producerFocusEffect = data['ratingData']['producerFocusEffect'];

        let producerFocusEffectClass = '';
        let producerFocusEffectIcon = '';
        if (producerFocusEffect >= 0) {
            producerFocusEffectClass = 'green';
            producerFocusEffectIcon = '<i class="fa fa-angle-double-up margin-right-5"></i>';
        }
        else {
            producerFocusEffectClass = 'dark-red';
            producerFocusEffect *= -1;
            producerFocusEffectIcon = '<i class="fa fa-angle-double-down margin-right-5"></i>';
        }
        if (producerFocusEffect === 0.25) {
            producerFocusEffect = 0.35;
        }
        let producerFocusRatingHtml = '<i class="star star-under fa fa-star margin-left-5">' +
            '<i class="star star-over fa fa-star ' + producerFocusEffectClass + '" style="width: ' + producerFocusEffect * 100 + '%"></i>' +
            '</i>';
        producerFocusEffectHtml = '<span class="display-block margin-top-2 help-text" title="Producers can focus on a segment to ' +
            'try and increase its rating.">' +
            '<span class="' + producerFocusEffectClass + ' line-height-1p4">' +
            producerFocusEffectIcon +
            'Producer Focus' + producerFocusRatingHtml +
            '</span></span>';
    }

    // Show producer xp change
    let producerXPChangeHtml = '';
    if (data['producerXpGained']) {
        let producerXPGained = '<span class="green margin-left-8">+ ' + data['producerXpGained'] + ' XP</span>';
        producerXPChangeHtml =
            '<div class="margin-top-5 font-0p925em medium-grey">' + data['producerName'] + producerXPGained + '</div>';
    }

    // Show result
    let text;
    let joinText = 'between';
    if (segment['participants'].length === 1 || data['managerSegment']) {
        joinText = 'with'
    }

    if (segment['productionSegment'] || segment['participants'].length <= 0) {
        joinText = 'for'
    }

    if (participantsHtml) {
        text = "<span class='faded-purple'>{0}</span> <span class='grey'>" + joinText + "</span> {1}";
        text = text.format(segment['name'], participantsHtml);
    }
    else {
        text = "<span class='faded-purple'>{0}</span>";
        text = text.format(segment['name']);
    }

    return '<div class=col1>' +
        text + feudsHtml + producerXPChangeHtml +
        '</div>' +
        '<div class="col2 text-right">' +
        rating + effectiveness + alreadyHeld + pureBoost + sillyResult + producerFocusEffectHtml +
        '</div>' +
        '<div class="clear"></div>';
}

function getEventResultParticipantManagersHtml(managersData, matchType) {
    let managersHtml = '';
    if (managersData.length > 0) {
        let managerHelpIcon = (matchType === 'segment') ?
            '<i class="fa fa-angle-double-up help-text margin-left-5 manager-color font-17px" ' +
            'title="Full-time Managers affect Segment Rating, depending on their Charisma"></i>' :
            '<i class="fa fa-angle-double-up help-text margin-left-5 manager-color font-17px" ' +
            'title="Full-time Managers have a chance to remove penalties for Dusty Match Finishes"></i>';

        // Get manager data for each manager of participant
        let participantManagerHtmls = [];
        managersData.forEach(function (managerData) {
            let participantManagerHtml;
            if (managerData['fullTimeManager']) {
                participantManagerHtml = '{0}{1}'.format(managerData['name'], managerHelpIcon);
            }
            else {
                participantManagerHtml = '{0}'.format(managerData['name']);
            }
            participantManagerHtmls.push(participantManagerHtml);
        });

        managersHtml = '<span class="margin-left-5 grey"><span>w/</span> {0}</span>'.format(commaSeparate(participantManagerHtmls, ' <span>and</span> '));
    }
    return managersHtml;
}

function showSegmentUpdates(data, segment) {
    let eventUpdatesSelector = $(".event-updates-other .updates-container");
    let eventUpdatesAvailabilitySelector = $(".event-updates-availability .updates-container");
    let eventUpdatesOvernessSelector = $(".event-updates-overness .updates-container");
    let eventUpdatesGimmicksSelector = $(".event-updates-gimmicks .updates-container");
    let eventUpdatesFeudsSelector = $(".event-updates-feuds .updates-container");
    let prestigeResultsSelector = $("#prestige-results");

    // Show heel turns
    data['turnedHeel'].forEach(function (turn) {
        let turnText = '';
        if (turn['shocking']) {
            let overnessIncrease = '<span class="hot-color">' + turn['overnessChange'] +
                '<span class="margin-left-2">%</span></span>';
            turnText =
                '<span class="holy-shit-text">' + 'HOLY SHIT! ' + '</span>' +
                turn['name'] + ' turned <span class="alignment-heel">Heel</span> in a shocking move, ' +
                'boosting ' + turn['pronoun'] + ' Overness by ' + overnessIncrease + '</span>';
            setTimeout(function () {
                $(".holy-shit-text").addClass("flash-text-grey");
            }, 200);
            setTimeout(function () {
                $(".holy-shit-text").removeClass("flash-text-grey");
            }, 2000);
        } else if (turn['tooSoon']) {
            let overnessDecrease = '<span class="stale-color">' + (turn['overnessChange'] * -1) +
                '<span class="margin-left-2">%</span></span>';
            turnText =
                turn['name'] + ' turned <span class="alignment-heel">Heel</span> too soon after a previous turn, ' +
                'lowering ' + turn['pronoun'] + ' Overness by ' + overnessDecrease + '</span>';
        } else {
            turnText = turn['name'] + ' turned <span class="alignment-heel">Heel</span>!'
        }

        eventUpdatesSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' +
            turnText +
            '</span>'
        );
    });

    // Show face turns
    data['turnedFace'].forEach(function (turn) {
        let turnText = '';
        if (turn['shocking']) {
            let overnessIncrease = '<span class="hot-color">' + turn['overnessChange'] +
                '<span class="margin-left-2">%</span></span>';
            turnText =
                '<span class="holy-shit-text">' + 'HOLY SHIT! ' + '</span>' +
                turn['name'] + ' turned <span class="alignment-face">Face</span> in a shocking move, ' +
                'boosting ' + turn['pronoun'] + ' Overness by ' + overnessIncrease + '</span>';
            setTimeout(function () {
                $(".holy-shit-text").addClass("flash-text-grey");
            }, 200);
            setTimeout(function () {
                $(".holy-shit-text").removeClass("flash-text-grey");
            }, 2000);
        } else if (turn['tooSoon']) {
            let overnessDecrease = '<span class="stale-color">' + (turn['overnessChange'] * -1) +
                '<span class="margin-left-2">%</span></span>';
            turnText =
                turn['name'] + ' turned <span class="alignment-face">Face</span> too soon after a previous turn, ' +
                'lowering ' + turn['pronoun'] + ' Overness by ' + overnessDecrease + '</span>';
        } else {
            turnText = turn['name'] + ' turned <span class="alignment-face">Face</span>!'
        }

        eventUpdatesSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' +
            turnText +
            '</span>'
        );
    });

    // Show neutral turns
    data['turnedNeutral'].forEach(function (turn) {
        let turnText = turn['name'] + ' turned <span class="alignment-neutral">Neutral</span>!';
        eventUpdatesSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' +
            turnText +
            '</span>'
        );
    });

    data['debutedGimmicks'].forEach(function (gimmick) {
        let gimmickDebutHtml = getGimmickDebutHtml(gimmick);
        eventUpdatesGimmicksSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' +
            gimmickDebutHtml +
            '</span>'
        );
    });

    // Charisma increases
    data['charismaIncreases'].forEach(function (superstar) {
        let text =
            '{0}\'s <span class="charisma-purple">Charisma</span> increased to <span class="gold">Level {1}</span>'
                .format(superstar['name'], superstar['level']);
        eventUpdatesSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' + text +
            '</span>'
        )
    });

    // Show vacated titles
    data['vacated'].forEach(function (vacated) {
        let text;
        let championshipName = getChampionshipDisplayName(vacated);
        if (!vacated['tagTeam'] && !vacated['trio']) {
            text = '<span class="gold">' + championshipName + '</span>' +
                ' has been vacated'
        } else {
            text = '<span class="gold">' + championshipName + '</span>' +
                ' have been vacated'
        }
        eventUpdatesSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' + text +
            '</span>'
        )
    });

    // Show awarded titles
    data['awarded'].forEach(function (awarded) {
        let text;
        let championshipName = getChampionshipDisplayName(awarded);
        if (!awarded['tagTeam'] && !awarded['trio']) {
            text = '<span class="gold">' + championshipName + '</span>' +
                ' has been awarded to ' + segment['participants'][0]['name']
        } else {
            text = '<span class="gold">' + championshipName + '</span>' +
                ' have been awarded to ' + segment['participants'][0]['name']
        }
        eventUpdatesSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' + text +
            '</span>'
        )
    });

    // Show created titles
    data['createdChampionships'].forEach(function (created) {
        let text;
        let championshipName = getChampionshipDisplayName(created);
        if (!created['tagTeam'] && !created['trio']) {
            text = '<span class="gold">' + championshipName + '</span>' +
                ' has been created'
        } else {
            text = '<span class="gold">' + championshipName + '</span>' +
                ' have been created'
        }
        eventUpdatesSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' + text +
            '</span>'
        )
    });

    // Fired
    data['fired'].forEach(function (superstar) {
        let overnessDecrease = '<span class="stale-color">' + superstar['overnessDecrease'] +
            '<span class="margin-left-2">%</span></span>';
        let text = superstar['name'] + ' was fired from the company, ' +
            'lowering ' + superstar['pronoun'] + ' Overness by ' + overnessDecrease;
        eventUpdatesAvailabilitySelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' +
            text +
            '</span>'
        );
    });

    // Feuds started
    data['feudsStarted'].forEach(function (feud) {
        let feudStartedHtml = getFeudStartedHtml(feud);
        eventUpdatesFeudsSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' +
            feudStartedHtml +
            '</span>'
        );
    });

    // Feud Potentials
    data['feudPotentials'].forEach(function (feud) {
        let feudPotentialHtml = getFeudPotentialHtml(feud);
        eventUpdatesFeudsSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' +
            feudPotentialHtml +
            '</span>'
        );
    });

    // Feud Potential
    data['feudHypeIncreased'].forEach(function (feud) {
        let feudHypeIncreased = getFeudHypeIncreasedHtml(feud);
        eventUpdatesFeudsSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' +
            feudHypeIncreased +
            '</span>'
        );
    });

    // Feud blowoff results
    data['feudsEnded'].forEach(function (feud) {
        let participantNames = feud['participants'].join(' and ');
        let feudName = feud['name'];
        let rating =
            '<span class="display-inline-block margin-left-8 top--1px">' + getStarRatingHtml(feud['rating']) + '</span>';
        let text =
            '<span class="faded-red-light">' + feudName + '</span>' +
            ' Feud between ' + participantNames + ' ended after the Blowoff' + rating;
        eventUpdatesFeudsSelector.prepend('<span class="display-block event-match-effect margin-bottom-12">' +
            text +
            '</span>');
    });

    // Feud prestige
    data['feudItemsLevelData'].forEach(function (levelData) {
        let levelText;
        let progress;
        let levelXp;
        if (levelData['level'] < 3) {
            levelXp = Math.pow(levelData['level'], 2) * 40;
            progress = (levelData['xp'] / levelXp) * 100;
        } else {
            levelXp = Math.pow(2, 2) * 40;
            progress = 100;
        }

        // Set level
        let level;
        switch (levelData['level']) {
            case 1:
                level = '<i class="fa fa-star-o margin-left-5 font-bold bronze"></i>';
                break;
            case 2:
                level = '<i class="fa fa-star-o margin-left-5 font-bold silver"></i>';
                break;
            case 3:
                level = '<i class="fa fa-star-o margin-left-5 font-bold gold-light"></i>';
                break;
        }

        let xpChangeHtml;
        let xpChange = levelData['xpChange'];
        if (xpChange >= 0) {
            xpChangeHtml = '<span class="prestige-xp-value green margin-left-8">+ ' + xpChange + '</span>'
        } else if (xpChange < 0) {
            xpChangeHtml = '<span class="prestige-xp-value red margin-left-8">- ' +
                (-1 * xpChange) + '</span>'
        }

        levelText =
            '<div class="display-block margin-bottom-5">' +
            '<div class="display-inline-block">' +
            '<span>' + levelData['name'] + '</span>' +
            level +
            '</div>' +
            '<div class="display-inline-block float-right">' +
            '<span class="margin-left-5 dark-grey prestige-xp">XP' +
            xpChangeHtml + '</span>' +
            '</div>' +
            '</div>' +
            '<div class="progress-under help-text" title="' + levelData['xp'] + ' / ' + levelXp + ' XP">' +
            '<div class="progress faded-red-light-background" style="width:' + progress + '%">' + '</div>' +
            '</div>';

        // Add level increase data
        if (levelData['levelIncrease']) {
            levelText +=
                '<span class="gold display-block margin-top-12 margin-bottom-2">Level Up!</span>' +
                '<span class="display-block medium-grey">Base Hype' +
                '<i class="fa fa-angle-double-up margin-left-8 margin-right-8"></i>' +
                '<span class="faded-red-light">' +
                '<i class="fa fa-bolt margin-right-5"></i>' +
                levelData['hypeIncrease'] +
                '</span>' +
                '</span>'
        }

        prestigeResultsSelector.find('.event-prestige-header').after('<div class="feud-item-level margin-bottom-25">' +
            levelText + '</div>');

        // Animate XP and progress
        $('.feud-item-level .prestige-xp-value').last().hide().fadeIn('slow');
        setTimeout(function () {
            $('.feud-item-level .progress').last().addClass("expand-width");
        }, 0);
        setTimeout(function () {
            $('.feud-item-level .progress').last().removeClass("expand-width");
        }, 1800);
    });

    // Show segment item prestige change
    let levelData = data['segmentItemLevelData'];
    if (levelData) {
        let levelHtml = getSegmentItemPrestigeChangeHtml(levelData);
        prestigeResultsSelector.find('.event-prestige-header').after('<div class="segment-item-level margin-bottom-25">' +
            levelHtml + '</div>');

        // Animate XP and progress
        $('.segment-item-level .prestige-xp-value').last().hide().fadeIn('slow');
        setTimeout(function () {
            $('.segment-item-level .progress').last().addClass("expand-width");
        }, 0);
        setTimeout(function () {
            $('.segment-item-level .progress').last().removeClass("expand-width");
        }, 1800);
    }

    // Disbanded tag teams
    if (data['disbanded'].length > 0) {
        let text = '{0} have disbanded'.format(commaSeparate(data['disbanded']));
        eventUpdatesAvailabilitySelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' +
            text +
            '</span>'
        );
    }

    // Show overness change
    if (data['hotSegment']) {
        let overnessChange = '<span class="hot-color">' + data['hotSegmentOvernessIncrease'] +
            '<span class="margin-left-2">%</span></span>';

        // Get participant names
        let participantNames = data['participantsData'].map(x => x['name']);

        let pronoun = 'their';
        let endText = ' each.';
        let participantsText;
        if (participantNames.length > 1) {
            participantsText = participantNames.slice(0, -1).join(', ') +
                ' and ' + participantNames.slice(-1)
        } else {
            participantsText = participantNames[0];
            pronoun = data['participantsData'][0]['pronoun'];
            endText = '.'
        }

        let segmentTypeText = '<span class="hot-color">Hot</span>';
        if (data['specialSegment']) {
            segmentTypeText = '<span class="special-segment-color">Special</span>';
        }

        let eventHypeBoost = '';
        if (data['eventHypeBoostData']) {
            if (data['eventHypeBoostData']['hotSegmentBoost']) {
                eventHypeBoost = ' A lot of viewers tuned in to watch.' +
                    '<span class="medium-dark-grey margin-left-8">+ ' + data['eventHypeBoostData']['hypeBoost'] + ' HYPE</span>';
            }
        }

        let hotSegmentText = participantsText + ' put on a ' + segmentTypeText + ' Segment, ' +
            'boosting ' + pronoun + ' Overness by ' + overnessChange + endText + eventHypeBoost;

        eventUpdatesOvernessSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' +
            hotSegmentText +
            '</span>'
        );
    }

    // Show hot feuds
    data['hotFeuds'].forEach(function (feud) {
        let overnessChange = '<span class="hot-color">' + feud['overnessIncrease'] +
            '<span class="margin-left-2">%</span></span>';

        // Get participant names
        let participantNames = [...feud['participants']];
        let participantsText = participantNames.slice(0, -1).join(', ') +
            ' and ' + participantNames.slice(-1);

        let feudName = feud['name'];
        let hotFeudText =
            '<span class="faded-red-light">{0}</span> Feud between {1} became <span class="hot-color">Hot</span>,'
                .format(feudName, participantsText) +
            ' boosting its chance to have Hot Matches and Segments and the Overness of the Participants by ' +
            overnessChange + ' each.';

        eventUpdatesOvernessSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' +
            hotFeudText +
            '</span>'
        );
    });

    // Overness changes
    data['overnessChanges'].forEach(function (overnessChange) {
        let overnessPercentage = '<span class="light-grey margin-left-5">' + overnessChange['overness'] +
            '<span class="margin-left-2">%</span></span>';
        let changeWord = (overnessChange['increase']) ? 'increased' : 'decreased';
        let text =
            '{0}\'s Overness{1} '.format(overnessChange['name'], overnessPercentage) + changeWord +
            ' from <span class="light-grey">' + overnessChange['previousOverness'] +
            ' to ' +
            overnessChange['currentOverness'] + '</span>';
        eventUpdatesOvernessSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' + text +
            '</span>'
        )
    });

    // Hot changes
    data['hotChanges'].forEach(function (hotChange) {
        let text = '';
        if (hotChange['status'] === 'hotStart') {
            text = hotChange['name'] + ' is starting to get <span class="hot-color">Over</span> with the Fans'
        } else if (hotChange['status'] === 'hotEnd') {
            text = hotChange['name'] + ' is no longer <span class="hot-color">Over</span> with the Fans. ' +
                'All boosts have been removed.'
        } else if (hotChange['status'] === 'hot') {
            text = hotChange['name'] + ' got <span class="hot-color hot-text">Over</span> with the Fans, ' +
                ' boosting ' + hotChange['pronoun'] + ' Workrate, Charisma, Popularity Changes, Gimmick Effectiveness, ' +
                ' Feud Hypes and the chance to have Hot Matches and Segments.'
        }
        eventUpdatesOvernessSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' + text +
            '</span>'
        );

        setTimeout(function () {
            $(".hot-text").addClass("flash-text-orange");
        }, 200);
        setTimeout(function () {
            $(".hot-text").removeClass("flash-text-orange");
        }, 3000);
    });

    // Stale changes
    data['staleChanges'].forEach(function (staleChange) {
        let text;
        if (staleChange['status'] === 'staleStart') {
            text = staleChange['name'] + ' is starting to become <span class="stale-color">Stale</span> with the Fans'
        } else if (staleChange['status'] === 'staleEnd') {
            text = staleChange['name'] + ' is no longer <span class="stale-color">Stale</span> with the Fans. ' +
                'All negative boosts have been removed.'
        } else if (staleChange['status'] === 'stale') {
            text = staleChange['name'] + ' became <span class="stale-color stale-text">Stale</span> with the Fans, ' +
                ' lowering ' + staleChange['pronoun'] + ' performance in Matches, Segments and Feuds.'
        }
        eventUpdatesOvernessSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' + text +
            '</span>'
        );

        setTimeout(function () {
            $(".stale-text").addClass("flash-text-stale");
        }, 200);
        setTimeout(function () {
            $(".stale-text").removeClass("flash-text-stale");
        }, 3000);
    });

    // Gimmick effectiveness level changes
    data['gimmickEffectivenessLevelChanges'].forEach(function (gimmickLevelChange) {
        let gimmickLevelChangeHtml = getGimmickEffectivenessLevelChangeHtml(gimmickLevelChange);
        eventUpdatesGimmicksSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' +
            gimmickLevelChangeHtml +
            '</span>'
        );
    });

    // Morale changes
    data['moraleChanges'].forEach(function (moraleChange) {
        let moralePercentage = '<span class="light-grey margin-left-5">' + moraleChange['morale'] +
            '<span class="margin-left-2">%</span></span>';
        let text =
            '{0}\'s Morale{1} '.format(moraleChange['name'], moralePercentage) +
            ' changed to <span class="light-grey">' + moraleChange['currentMorale'] +
            '</span> from <span class="light-grey">' + moraleChange['previousMorale'] + '</span>';
        eventUpdatesSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' + text +
            '</span>'
        )
    });

    // Staff skill increases
    data['staffSkillIncreases'].forEach(function (staffMember) {
        let roleHtml = '<span class="light-grey">(' + toTitleCase(staffMember['role'].replace(/_/g, " ")) + ')</span>';
        let skillLevelHtml = '<span class="staff-color">Skill</span>';
        let text =
            '{0}\'s {1} {2} increased to <span class="gold">Level {3}</span>'
                .format(staffMember['name'], roleHtml, skillLevelHtml, staffMember['level']);
        eventUpdatesSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' + text +
            '</span>'
        )
    });

    // Suspensions
    data['suspended'].forEach(function (superstar) {
        let monthsWord = getMonthsWord(superstar['months']);
        let text = '{0} has been suspended for {1} {2}'.format(superstar['name'], superstar['months'], monthsWord);
        eventUpdatesSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' + text +
            '</span>'
        )
    });

    // Unavailable
    data['unavailable'].forEach(function (superstar) {
        let text = '{0} has left the company for some time'.format(superstar['name']);
        eventUpdatesSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' + text +
            '</span>'
        )
    });

    // Retirements
    data['retirements'].forEach(function (superstar) {
        let text;
        if (superstar['hallOfFame']) {
            text =
                superstar['name'] +
                ' has retired and been inducted into the ' +
                '<span class="gold">' +
                'Hall of Fame' +
                '</span>'
        } else {
            text =
                superstar['name'] +
                " has retired from wrestling"
        }
        eventUpdatesSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' + text +
            '</span>'
        )
    });

    // Tag Teams created
    data['teamsCreated'].forEach(function (team) {
        let text = 'Created a Team of {0} called {1}'.format(team['superstars'], team['name']);
        eventUpdatesSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' + text +
            '</span>'
        )
    });

    // Special segment consequence
    if (data['specialSegmentConsequence']) {
        let specialSegmentConsequence = data['specialSegmentConsequence'];
        if (specialSegmentConsequence['unavailableSuperstar']) {
            let text = '{0} is not available for some time'.format(specialSegmentConsequence['unavailableSuperstar']);
            eventUpdatesSelector.prepend(
                '<span class="display-block margin-bottom-12 dark-grey">' + text +
                '</span>'
            )
        }
        if (specialSegmentConsequence['unavailableStaffMember']) {
            let text = '{0} is not available for some time'.format(specialSegmentConsequence['unavailableStaffMember']);
            eventUpdatesSelector.prepend(
                '<span class="display-block margin-bottom-12 dark-grey">' + text +
                '</span>'
            )
        }
        if (specialSegmentConsequence['unhappySuperstars']) {
            let text = '{0} are unhappy with the {1}'.format(commaSeparate(specialSegmentConsequence['unhappySuperstars']), specialSegmentConsequence['unhappyReason']);
            eventUpdatesSelector.prepend(
                '<span class="display-block margin-bottom-12 dark-grey">' + text +
                '</span>'
            )
        }
        if (specialSegmentConsequence['suspendedSuperstar']) {
            let text = '{0} has been suspended for 1 month'.format(specialSegmentConsequence['suspendedSuperstar']);
            eventUpdatesSelector.prepend(
                '<span class="display-block margin-bottom-12 dark-grey">' + text +
                '</span>'
            )
        }
        if (specialSegmentConsequence['creativePointsPenalty']) {
            let pointsHtml = '<span class="blue margin-right-3">{0}</span>'.format(specialSegmentConsequence['creativePointsPenalty']);
            let pointsImageHtml = '<img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small margin-left-3 margin-right-5"/>{0}'.format(pointsHtml);
            let text = 'Due to sponsor backlash, {0} took away {1}'.format(data['specialSegmentConsequence']['ownerName'], pointsImageHtml);
            eventUpdatesSelector.prepend(
                '<span class="display-block margin-bottom-12 dark-grey">' + text +
                '</span>'
            )
        }
    }

    // Faction segment consequence
    if (data['factionSegmentConsequence']) {
        let factionSegmentConsequence = data['factionSegmentConsequence'];
        if (factionSegmentConsequence['removedFactionMembers']) {

            // Get popularity change html
            let popularityChangeHtml = '';
            if (factionSegmentConsequence['popularityChange']) {
                let popularityChangeValueHtml = '';
                if (factionSegmentConsequence['popularityChange'] < 0) {
                    popularityChangeValueHtml = '<span class="margin-left-2 red">- ' + (factionSegmentConsequence['popularityChange'] * -1) + '</span>'
                } else {
                    popularityChangeValueHtml = '<span class="margin-left-2 green">+ ' + factionSegmentConsequence['popularityChange'] + '</span>'
                }
                popularityChangeHtml = ', changing Popularity by ' + popularityChangeValueHtml + '</span>';
            }

            // Add removed members html
            let factionSegmentConsequenceVerb = (factionSegmentConsequence['removedFactionMembers'].length < 2) ? 'was' : 'were';
            let text = commaSeparate(factionSegmentConsequence['removedFactionMembers']) + " " + factionSegmentConsequenceVerb +
                " removed from " + factionSegmentConsequence['faction'] + popularityChangeHtml;
            eventUpdatesSelector.prepend(
                '<span class="display-block margin-bottom-12 dark-grey">' + text +
                '</span>'
            )
        }
        if (factionSegmentConsequence['addedFactionMembers']) {

            // Get popularity change html
            let popularityChangeHtml = '';
            if (factionSegmentConsequence['popularityChange']) {
                let popularityChangeValueHtml = '';
                if (factionSegmentConsequence['popularityChange'] < 0) {
                    popularityChangeValueHtml = '<span class="margin-left-2 red">- ' + (factionSegmentConsequence['popularityChange'] * -1) + '</span>'
                } else {
                    popularityChangeValueHtml = '<span class="margin-left-2 green">+ ' + factionSegmentConsequence['popularityChange'] + '</span>'
                }
                popularityChangeHtml = ', changing Popularity by ' + popularityChangeValueHtml + '</span>';
            }

            // Add added members html
            let factionSegmentConsequenceVerb = (factionSegmentConsequence['addedFactionMembers'].length < 2) ? 'was' : 'were';
            let text = commaSeparate(factionSegmentConsequence['addedFactionMembers']) + " " + factionSegmentConsequenceVerb +
                " added to " + factionSegmentConsequence['faction'] + popularityChangeHtml;
            eventUpdatesSelector.prepend(
                '<span class="display-block margin-bottom-12 dark-grey">' + text +
                '</span>'
            )
        }
        if (factionSegmentConsequence['setFactionLeader']) {
            let text = factionSegmentConsequence['setFactionLeader'] + " was set as the leader of " + factionSegmentConsequence['faction'];
            eventUpdatesSelector.prepend(
                '<span class="display-block margin-bottom-12 dark-grey">' + text +
                '</span>'
            )
        }
        if (factionSegmentConsequence['movedFactionMembers']) {
            let text = commaSeparate(factionSegmentConsequence['movedFactionMembers']) + " left " +
                factionSegmentConsequence['faction'] + " and joined " + factionSegmentConsequence['consequenceFaction'];
            eventUpdatesSelector.prepend(
                '<span class="display-block margin-bottom-12 dark-grey">' + text +
                '</span>'
            )
        }
        if (factionSegmentConsequence['mergedFactions']) {
            let text = commaSeparate(factionSegmentConsequence['mergedFactions']) + " merged to form " + factionSegmentConsequence['createdFactionName'];
            eventUpdatesSelector.prepend(
                '<span class="display-block margin-bottom-12 dark-grey">' + text +
                '</span>'
            )
        }
        if (factionSegmentConsequence['newFactionMembers']) {
            let text = commaSeparate(factionSegmentConsequence['newFactionMembers']) + " left " +
                factionSegmentConsequence['faction'] + " to form " + factionSegmentConsequence['createdFactionName'];
            eventUpdatesSelector.prepend(
                '<span class="display-block margin-bottom-12 dark-grey">' + text +
                '</span>'
            )
        }
        if (factionSegmentConsequence['removedFactionLeader']) {
            let text = factionSegmentConsequence['removedFactionLeader'] + " was removed as the leader of " + factionSegmentConsequence['faction'];
            eventUpdatesSelector.prepend(
                '<span class="display-block margin-bottom-12 dark-grey">' + text +
                '</span>'
            )
        }
        if (factionSegmentConsequence['disbandedFaction']) {
            let text = factionSegmentConsequence['disbandedFaction'] + " have disbanded";
            eventUpdatesSelector.prepend(
                '<span class="display-block margin-bottom-12 dark-grey">' + text +
                '</span>'
            )
        }
        if (factionSegmentConsequence['createdFactionMembers']) {
            let text = commaSeparate(factionSegmentConsequence['createdFactionMembers']) + " formed " + factionSegmentConsequence['createdFactionName'];
            eventUpdatesSelector.prepend(
                '<span class="display-block margin-bottom-12 dark-grey">' + text +
                '</span>'
            )
        }
    }

    // Managers added/removed
    data['managersAdded'].forEach(function (managerAdded) {
        let text = '<span class="display-block">Assigned {0} to manage {1}</span>'.format(managerAdded['managerName'], commaSeparate(managerAdded['managedSuperstarsNames']));
        eventUpdatesSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' + text +
            '</span>'
        )
    });
    data['managersRemoved'].forEach(function (managerRemoved) {
        let text = '<span class="display-block">Removed {0} from managing {1}</span>'.format(managerRemoved['managerName'], commaSeparate(managerRemoved['removedSuperstarsNames']));
        eventUpdatesSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' + text +
            '</span>'
        )
    });

    // Show faction reputation progress
    data['factionReputationsData'].forEach(function (factionReputationData) {
        showFactionReputationData(factionReputationData);
    });

    // Show championship prestige progress
    data['championshipPrestiges'].forEach(function (prestigeData) {
        let prestigeHtml = getChampionshipPrestigeHtml(prestigeData);
        prestigeResultsSelector.find('.event-prestige-header').after('<div class="championship-prestige margin-bottom-20">' +
            prestigeHtml + '</div>');
        $('.championship-prestige .prestige-xp').hide().fadeIn('slow');

        setTimeout(function () {
            $('.championship-prestige .progress').addClass("expand-width");
        }, 0);
        setTimeout(function () {
            $('.championship-prestige .progress').removeClass("expand-width");
        }, 1800);
    });

    // Show unlocked segment items
    data['unlockedSegmentItems'].forEach(function (segmentItem) {
        let unlockText = '<span class="faded-purple">' + segmentItem + '</span>' + ' Segment Item unlocked!';
        let html = '<span class="display-block margin-bottom-15">' +
            unlockText +
            '</span>';
        prestigeResultsSelector.find('.event-prestige-header').after(html);
    });

    // Show unlocked championship segment items
    data['unlockedChampionshipSegmentItems'].forEach(function (segmentItem) {
        let unlockText = '<span class="faded-purple">' + segmentItem + '</span>' + ' Championship Segment unlocked!';
        let html = '<span class="display-block margin-bottom-15">' +
            unlockText +
            '</span>';
        prestigeResultsSelector.find('.event-prestige-header').after(html);
    });

    // Show unlocked gimmick characters
    data['unlockedCharacters'].forEach(function (unlockedCharacter) {
        let unlockText = '<span class="character-label">' + unlockedCharacter['name'] + '</span>' +
            ' Character unlocked due to the ' + unlockedCharacter['originalCharacter'] +
            ' Character getting Over!';
        let html = '<span class="display-block margin-bottom-15">' +
            unlockText +
            '</span>';
        prestigeResultsSelector.find('.event-prestige-header').after(html);
    });

    // Show unlocked feud items
    data['unlockedFeudItems'].forEach(function (feudItem) {
        let unlockText = '<span class="faded-red-light">' + feudItem + '</span>' + ' Feud Item unlocked!';
        let html = '<span class="display-block margin-bottom-15">' +
            unlockText +
            '</span>';
        prestigeResultsSelector.find('.event-prestige-header').after(html);
    });

    // Brand changes
    data['brandChanges'].forEach(function (brandChange) {
        let text = '<span class="display-block">{0} moved to {1}</span>'.format(brandChange['name'], brandChange['brandName']);
        eventUpdatesSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' + text +
            '</span>'
        )
    });

    // Mask removed
    data['maskRemoved'].forEach(function (maskRemoved) {
        let text = '<span class="display-block">{0} removed {1} mask!</span>'.format(maskRemoved['name'], maskRemoved['possessivePronoun']);
        eventUpdatesSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' + text +
            '</span>'
        )
    });

    // Unified
    if (data['unifiedChampionships']) {
        let unifiedData = data['unifiedChampionships'];
        let championshipVerb = (unifiedData['multipleChampionships']) ? 'have' : 'has';
        let unifiedChampionshipsName = '<span class="gold">{0}</span>'.format(
            unifiedData['unifiedChampionships']);
        let unifiedChampionshipWithName = '<span class="gold">{0}</span>'.format(
            unifiedData['unifiedChampionshipWith']);

        let text = '{0} {1} been unified with the {2}'.format(
            unifiedChampionshipsName, championshipVerb,
            unifiedChampionshipWithName);

        // Show new championship name
        if (unifiedData['newChampionshipName']) {
            text += ', creating the <span class="gold">{0}</span>'.format(unifiedData['newChampionshipName']);
        }

        // Show prestige xp change
        if (unifiedData['xpChange']) {
            let xpChange = '<span class="green margin-left-5">+ ' +
                unifiedData['xpChange'] + ' XP</span>';
            text += ', increasing Prestige {0}'.format(xpChange);
        }

        eventUpdatesSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' +
            text +
            '</span>'
        );
    }

    // Show event hype boosts
    let eventHypeBoostData = data['eventHypeBoostData'];
    if (eventHypeBoostData) {
        // Show debut boost
        let debutText;
        if (eventHypeBoostData['debutBoost']) {
            debutText = 'Former ' + eventHypeBoostData['formerCompanyName'] + ' talent ' + data['participantsData'][0]['name'] +
                ' showed up in ' + eventHypeBoostData['companyName'] + '!';
            let text = debutText + ' A lot of viewers tuned in to watch the debut.' +
                '<span class="medium-dark-grey margin-left-8">+ ' + eventHypeBoostData['hypeBoost'] + ' HYPE</span>';
            eventUpdatesSelector.prepend(
                '<span class="display-block margin-bottom-12 dark-grey">' +
                text +
                '</span>'
            );
        }

        // Show slander boost
        if (eventHypeBoostData['slanderBoost']) {
            debutText = data['participantsData'][0]['name'] + ' slandered ' + eventHypeBoostData['competitorName'] + '.';
            let text = debutText + ' It seemed to work, as a lot of viewers tuned in to watch the segment.' +
                '<span class="medium-dark-grey margin-left-8">+ ' + eventHypeBoostData['hypeBoost'] + ' HYPE</span>';
            eventUpdatesSelector.prepend(
                '<span class="display-block margin-bottom-12 dark-grey">' +
                text +
                '</span>'
            );
        }

        // Show slander penalty
        if (eventHypeBoostData['slanderPenalty']) {
            debutText = data['participantsData'][0]['name'] + ' slandered ' + eventHypeBoostData['competitorName'] + '.';
            let text = debutText + ' A lot of viewers found it in bad taste and tuned out.' +
                '<span class="medium-dark-grey margin-left-8">- ' + (eventHypeBoostData['hypeBoost'] * -1) + ' HYPE</span>';
            eventUpdatesSelector.prepend(
                '<span class="display-block margin-bottom-12 dark-grey">' +
                text +
                '</span>'
            );
        }

        // Update event hype
        $('.event-hype-text').html(getEventHypeHtml(data['eventHype'])).hide().fadeIn('fast');
    }
}

function animateGimmickEffectiveness() {
    $('.gimmick-effectiveness').each(function (i, e) {
        let effectiveness = $(e).data('value');
        let animationStarted = $(e).data('animationStarted');
        if (!animationStarted) {
            let i = 0;
            let overnessChange = $(e).data('overness-change');
            let productionBoost = $(e).data('production-boost');
            $(e).data('animationStarted', true);
            let eff = setInterval(function () {
                $(e).text(i);
                i++;
                if (i === effectiveness + 1 || i > 120) {
                    clearInterval(eff);

                    // Gimmick Overness Effect Change
                    let overnessChangeHtml = '';
                    if (overnessChange !== 0) {
                        if (overnessChange < 0) {
                            overnessChange *= -1;
                            overnessChangeHtml = '<span class="red">- ' + overnessChange + '</span>'
                        } else {
                            overnessChangeHtml = '<span class="green">+ ' + overnessChange + '</span>'
                        }
                        overnessChangeHtml = '<span class="margin-left-8">changing Overness by ' +
                            overnessChangeHtml + '</span>';
                    }

                    // Production Boost
                    let productionBoostHtml = '';
                    if (productionBoost) {
                        productionBoostHtml =
                            '<div class="light-grey font-0p925em">(' +
                            '+ ' + productionBoost + '% Production Boost)</div>';
                    }

                    $(e).parent().next('.gimmick-effectiveness-text').html(
                        getGimmickEffectivenessHtml(effectiveness) + overnessChangeHtml +
                        productionBoostHtml
                    )
                }
                if (i > 120) {
                    $(e).text(effectiveness);
                }
            }, 45, i);
        }
    });
}

function getSegmentItemPrestigeChangeHtml(data) {
    let progress;
    let levelXp;
    if (data['level'] < 3) {
        levelXp = Math.pow(data['level'], 2) * 75;
        progress = (data['xp'] / levelXp) * 100;
    } else {
        levelXp = Math.pow(2, 2) * 75;
        progress = 100;
    }

    // Set level
    let level;
    switch (data['level']) {
        case 1:
            level = '<i class="fa fa-star-o margin-left-5 font-bold bronze"></i>';
            break;
        case 2:
            level = '<i class="fa fa-star-o margin-left-5 font-bold silver"></i>';
            break;
        case 3:
            level = '<i class="fa fa-star-o margin-left-5 font-bold gold-light"></i>';
            break;
    }

    let xpChangeHtml;
    let xpChange = data['xpChange'];
    if (xpChange >= 0) {
        xpChangeHtml = '<span class="prestige-xp-value green margin-left-8">+ ' + xpChange + '</span>'
    } else if (xpChange < 0) {
        xpChangeHtml = '<span class="prestige-xp-value red margin-left-8">- ' +
            (-1 * xpChange) + '</span>'
    }

    let prestigeChangeHtml =
        '<div class="display-block margin-bottom-5">' +
        '<div class="display-inline-block">' +
        '<span>' + data['name'] + '</span>' +
        level +
        '</div>' +
        '<div class="display-inline-block float-right">' +
        '<span class="margin-left-5 dark-grey prestige-xp">XP' +
        xpChangeHtml + '</span>' +
        '</div>' +
        '</div>' +
        '<div class="progress-under help-text" title="' + data['xp'] + ' / ' + levelXp + ' XP">' +
        '<div class="progress faded-purple-background" style="width:' + progress + '%">' + '</div>' +
        '</div>';

    // Add level increase data
    if (data['levelIncrease']) {
        let perk;
        switch (data['addedPerk']) {
            case 'entertainment':
                perk = 'Entertainment increased for this Segment Item!';
                break;
            case 'action':
                perk = 'Action increased for this Segment Item!';
                break;
            case 'difficulty':
                perk = 'Difficulty decreased for this Segment Item!';
                break;
            case 'hype':
                perk = 'Hype Boost increased for this Segment Item!';
                break;
            case 'popularity':
                perk = 'Popularity Boost increased for this Segment Item!';
                break;
            case 'cost':
                perk = 'Cost decreased for this Segment Item!';
                break;
        }
        prestigeChangeHtml +=
            '<span class="gold display-block margin-top-12 margin-bottom-2">Level Up!</span>' +
            '<span class="display-block medium-grey">' + perk + '</span>'
    }

    return prestigeChangeHtml;
}

function showUpdatesContainers() {
    $('.updates-container').each(function (i, el) {
        if ($(el).children().length > 0) {
            $(el).parent().fadeIn('slow');
            $('#event-updates').fadeIn('slow');
        }
    });
    if ($("#prestige-results").children().length > 1) {
        $("#prestige-results").fadeIn('slow');
    }
}

function formatSegmentText(text) {
    text = replaceAll(text, '{name}', '{0}');
    text = replaceAll(text, '{objective}', '{1}');
    text = replaceAll(text, '{possessive}', '{2}');
    text = replaceAll(text, '{pronoun}', '{3}');

    // Parse keywords for participants
    for (let i = 1; i < 9; i++) {
        text = replaceAll(text, '{name{0}}'.format(i), '{{0}}'.format(4 * i - 4));
        text = replaceAll(text, '{objective{0}}'.format(i), '{{0}}'.format(4 * i - 3));
        text = replaceAll(text, '{possessive{0}}'.format(i), '{{0}}'.format(4 * i - 2));
        text = replaceAll(text, '{pronoun{0}}'.format(i), '{{0}}'.format(4 * i - 1));
    }

    return text;
}

function getMatchOrSegmentParticipantName(participant) {
    let managerText = (participant['managerNames'] && participant['managerNames'].length > 0) ?
        '<span class="grey display-block cursor-pointer"> w/ {0}</span>'.format(commaSeparate(participant['managerNames'])) : '';
    return participant['name'] + managerText;
}

function viewAnnualTournamentSegmentStart(segment, matchesAndSegmentsData, index, tournamentDisplay) {
    let matchInfoSelector = $("#match-info");
    matchInfoSelector.html('').removeClass('visibility-hidden').show();

    // Show segment name
    matchInfoSelector.append(
        "<span class='font-bold display-block margin-bottom-3 faded-purple'>" + segment['name'] + "</span>"
    );

    // Add start text
    let segmentStartText = getRandomChoice(segment['startTexts']);
    let segmentStartHtml =
        '<span class="font-bold display-block margin-bottom-10 margin-top-10 medium-dark-grey segment-start-text">' +
        segmentStartText +
        '</span>';
    $(segmentStartHtml).hide().appendTo(matchInfoSelector).fadeIn(700);

    matchInfoSelector.fadeIn('slow');

    $("#match").html('').show();
    $('#match').append('<div class="match-superstar-information information-box"></div>')
    $('.match-superstar-information').hide();

    // Add information box
    $(".match-container").fadeIn('slow');
    $('#booking-talent-info').html('');

    // Load graphics
    showPlaySegmentPageGraphic(segment);

    // Go to action text after some time
    setTimeout(function () {
        viewAnnualTournamentSegmentAction(segment, matchesAndSegmentsData, index, tournamentDisplay);
    }, 2800);
}

function viewAnnualTournamentSegmentAction(segment, matchesAndSegmentsData, index, tournamentDisplay) {
    let matchInfoSelector = $("#match-info");

    // Add action text
    let segmentActionText = getRandomChoice(segment['actionTexts']);
    let segmentActionHtml =
        '<span class="font-bold display-block medium-dark-grey segment-action-text">' +
        segmentActionText +
        '</span>';
    $(segmentActionHtml).hide().appendTo(matchInfoSelector).fadeIn(700);
    $('.segment-start-text').removeClass('medium-dark-grey').addClass('light-grey');

    // Load graphics
    showPlaySegmentPageGraphic(segment, true);

    // Show 'continue' button
    $('.match-superstar-information').before('' +
        '<div class="margin-sides-auto margin-top-15">' +
        '<button type="button" class="button retro-button grey-button-background" id="progress-segment-button">Continue</button>' +
        '</div>');

    // Increase index
    index++;

    // Progress segment handler
    $("#match").off('click', '#progress-segment-button');
    $("#match").on('click', '#progress-segment-button', async function () {
        await showPlayMatchOrSegmentPage({data: {'matchesAndSegmentsData': matchesAndSegmentsData, 'cashinData': {},
            'tournamentDisplay': tournamentDisplay}, index});
    });
}

export {viewSpecialSegmentStart, showViewSpecialSegmentsPageData, showGetAvailableSegmentItemsData, showPlaySegmentPage,
    getMatchOrSegmentParticipantName, showUpdatesContainers, animateGimmickEffectiveness, getEventResultParticipantManagersHtml}